import Dn, { createContext as Vr, useContext as qr, useState as zr, useRef as wt, useEffect as vt, useMemo as Kr, createElement as Jr } from "react";
const en = {
  STAFF_CONSOLE: { id: "STAFF_CONSOLE", name: "Staff Console" },
  ACCOUNTS_MGMT: { id: "ACCOUNTS_MGMT", name: "Accounts Management" }
};
var St = { exports: {} }, Ee = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var tn;
function Gr() {
  if (tn)
    return Ee;
  tn = 1;
  var n = Dn, e = Symbol.for("react.element"), t = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, s = n.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function o(u, a, l) {
    var f, p = {}, d = null, m = null;
    l !== void 0 && (d = "" + l), a.key !== void 0 && (d = "" + a.key), a.ref !== void 0 && (m = a.ref);
    for (f in a)
      r.call(a, f) && !i.hasOwnProperty(f) && (p[f] = a[f]);
    if (u && u.defaultProps)
      for (f in a = u.defaultProps, a)
        p[f] === void 0 && (p[f] = a[f]);
    return { $$typeof: e, type: u, key: d, ref: m, props: p, _owner: s.current };
  }
  return Ee.Fragment = t, Ee.jsx = o, Ee.jsxs = o, Ee;
}
var Re = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var nn;
function Wr() {
  return nn || (nn = 1, process.env.NODE_ENV !== "production" && function() {
    var n = Dn, e = Symbol.for("react.element"), t = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), s = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), u = Symbol.for("react.context"), a = Symbol.for("react.forward_ref"), l = Symbol.for("react.suspense"), f = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), d = Symbol.for("react.lazy"), m = Symbol.for("react.offscreen"), h = Symbol.iterator, w = "@@iterator";
    function y(c) {
      if (c === null || typeof c != "object")
        return null;
      var b = h && c[h] || c[w];
      return typeof b == "function" ? b : null;
    }
    var v = n.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function x(c) {
      {
        for (var b = arguments.length, S = new Array(b > 1 ? b - 1 : 0), O = 1; O < b; O++)
          S[O - 1] = arguments[O];
        E("error", c, S);
      }
    }
    function E(c, b, S) {
      {
        var O = v.ReactDebugCurrentFrame, k = O.getStackAddendum();
        k !== "" && (b += "%s", S = S.concat([k]));
        var F = S.map(function(N) {
          return String(N);
        });
        F.unshift("Warning: " + b), Function.prototype.apply.call(console[c], console, F);
      }
    }
    var R = !1, A = !1, C = !1, L = !1, Q = !1, se;
    se = Symbol.for("react.module.reference");
    function De(c) {
      return !!(typeof c == "string" || typeof c == "function" || c === r || c === i || Q || c === s || c === l || c === f || L || c === m || R || A || C || typeof c == "object" && c !== null && (c.$$typeof === d || c.$$typeof === p || c.$$typeof === o || c.$$typeof === u || c.$$typeof === a || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      c.$$typeof === se || c.getModuleId !== void 0));
    }
    function ie(c, b, S) {
      var O = c.displayName;
      if (O)
        return O;
      var k = b.displayName || b.name || "";
      return k !== "" ? S + "(" + k + ")" : S;
    }
    function rt(c) {
      return c.displayName || "Context";
    }
    function G(c) {
      if (c == null)
        return null;
      if (typeof c.tag == "number" && x("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof c == "function")
        return c.displayName || c.name || null;
      if (typeof c == "string")
        return c;
      switch (c) {
        case r:
          return "Fragment";
        case t:
          return "Portal";
        case i:
          return "Profiler";
        case s:
          return "StrictMode";
        case l:
          return "Suspense";
        case f:
          return "SuspenseList";
      }
      if (typeof c == "object")
        switch (c.$$typeof) {
          case u:
            var b = c;
            return rt(b) + ".Consumer";
          case o:
            var S = c;
            return rt(S._context) + ".Provider";
          case a:
            return ie(c, c.render, "ForwardRef");
          case p:
            var O = c.displayName || null;
            return O !== null ? O : G(c.type) || "Memo";
          case d: {
            var k = c, F = k._payload, N = k._init;
            try {
              return G(N(F));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var K = Object.assign, X = 0, oe, we, B, ee, ne, ve, _t;
    function Ut() {
    }
    Ut.__reactDisabledLog = !0;
    function mr() {
      {
        if (X === 0) {
          oe = console.log, we = console.info, B = console.warn, ee = console.error, ne = console.group, ve = console.groupCollapsed, _t = console.groupEnd;
          var c = {
            configurable: !0,
            enumerable: !0,
            value: Ut,
            writable: !0
          };
          Object.defineProperties(console, {
            info: c,
            log: c,
            warn: c,
            error: c,
            group: c,
            groupCollapsed: c,
            groupEnd: c
          });
        }
        X++;
      }
    }
    function yr() {
      {
        if (X--, X === 0) {
          var c = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: K({}, c, {
              value: oe
            }),
            info: K({}, c, {
              value: we
            }),
            warn: K({}, c, {
              value: B
            }),
            error: K({}, c, {
              value: ee
            }),
            group: K({}, c, {
              value: ne
            }),
            groupCollapsed: K({}, c, {
              value: ve
            }),
            groupEnd: K({}, c, {
              value: _t
            })
          });
        }
        X < 0 && x("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var st = v.ReactCurrentDispatcher, it;
    function je(c, b, S) {
      {
        if (it === void 0)
          try {
            throw Error();
          } catch (k) {
            var O = k.stack.trim().match(/\n( *(at )?)/);
            it = O && O[1] || "";
          }
        return `
` + it + c;
      }
    }
    var ot = !1, _e;
    {
      var br = typeof WeakMap == "function" ? WeakMap : Map;
      _e = new br();
    }
    function Bt(c, b) {
      if (!c || ot)
        return "";
      {
        var S = _e.get(c);
        if (S !== void 0)
          return S;
      }
      var O;
      ot = !0;
      var k = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var F;
      F = st.current, st.current = null, mr();
      try {
        if (b) {
          var N = function() {
            throw Error();
          };
          if (Object.defineProperty(N.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(N, []);
            } catch (V) {
              O = V;
            }
            Reflect.construct(c, [], N);
          } else {
            try {
              N.call();
            } catch (V) {
              O = V;
            }
            c.call(N.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (V) {
            O = V;
          }
          c();
        }
      } catch (V) {
        if (V && O && typeof V.stack == "string") {
          for (var P = V.stack.split(`
`), H = O.stack.split(`
`), I = P.length - 1, j = H.length - 1; I >= 1 && j >= 0 && P[I] !== H[j]; )
            j--;
          for (; I >= 1 && j >= 0; I--, j--)
            if (P[I] !== H[j]) {
              if (I !== 1 || j !== 1)
                do
                  if (I--, j--, j < 0 || P[I] !== H[j]) {
                    var W = `
` + P[I].replace(" at new ", " at ");
                    return c.displayName && W.includes("<anonymous>") && (W = W.replace("<anonymous>", c.displayName)), typeof c == "function" && _e.set(c, W), W;
                  }
                while (I >= 1 && j >= 0);
              break;
            }
        }
      } finally {
        ot = !1, st.current = F, yr(), Error.prepareStackTrace = k;
      }
      var de = c ? c.displayName || c.name : "", ae = de ? je(de) : "";
      return typeof c == "function" && _e.set(c, ae), ae;
    }
    function wr(c, b, S) {
      return Bt(c, !1);
    }
    function vr(c) {
      var b = c.prototype;
      return !!(b && b.isReactComponent);
    }
    function Ue(c, b, S) {
      if (c == null)
        return "";
      if (typeof c == "function")
        return Bt(c, vr(c));
      if (typeof c == "string")
        return je(c);
      switch (c) {
        case l:
          return je("Suspense");
        case f:
          return je("SuspenseList");
      }
      if (typeof c == "object")
        switch (c.$$typeof) {
          case a:
            return wr(c.render);
          case p:
            return Ue(c.type, b, S);
          case d: {
            var O = c, k = O._payload, F = O._init;
            try {
              return Ue(F(k), b, S);
            } catch {
            }
          }
        }
      return "";
    }
    var Se = Object.prototype.hasOwnProperty, Mt = {}, Ht = v.ReactDebugCurrentFrame;
    function Be(c) {
      if (c) {
        var b = c._owner, S = Ue(c.type, c._source, b ? b.type : null);
        Ht.setExtraStackFrame(S);
      } else
        Ht.setExtraStackFrame(null);
    }
    function Sr(c, b, S, O, k) {
      {
        var F = Function.call.bind(Se);
        for (var N in c)
          if (F(c, N)) {
            var P = void 0;
            try {
              if (typeof c[N] != "function") {
                var H = Error((O || "React class") + ": " + S + " type `" + N + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof c[N] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw H.name = "Invariant Violation", H;
              }
              P = c[N](b, N, O, S, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (I) {
              P = I;
            }
            P && !(P instanceof Error) && (Be(k), x("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", O || "React class", S, N, typeof P), Be(null)), P instanceof Error && !(P.message in Mt) && (Mt[P.message] = !0, Be(k), x("Failed %s type: %s", S, P.message), Be(null));
          }
      }
    }
    var xr = Array.isArray;
    function at(c) {
      return xr(c);
    }
    function Er(c) {
      {
        var b = typeof Symbol == "function" && Symbol.toStringTag, S = b && c[Symbol.toStringTag] || c.constructor.name || "Object";
        return S;
      }
    }
    function Rr(c) {
      try {
        return Vt(c), !1;
      } catch {
        return !0;
      }
    }
    function Vt(c) {
      return "" + c;
    }
    function qt(c) {
      if (Rr(c))
        return x("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Er(c)), Vt(c);
    }
    var xe = v.ReactCurrentOwner, Or = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, zt, Kt, ut;
    ut = {};
    function Ar(c) {
      if (Se.call(c, "ref")) {
        var b = Object.getOwnPropertyDescriptor(c, "ref").get;
        if (b && b.isReactWarning)
          return !1;
      }
      return c.ref !== void 0;
    }
    function Tr(c) {
      if (Se.call(c, "key")) {
        var b = Object.getOwnPropertyDescriptor(c, "key").get;
        if (b && b.isReactWarning)
          return !1;
      }
      return c.key !== void 0;
    }
    function Cr(c, b) {
      if (typeof c.ref == "string" && xe.current && b && xe.current.stateNode !== b) {
        var S = G(xe.current.type);
        ut[S] || (x('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', G(xe.current.type), c.ref), ut[S] = !0);
      }
    }
    function Pr(c, b) {
      {
        var S = function() {
          zt || (zt = !0, x("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", b));
        };
        S.isReactWarning = !0, Object.defineProperty(c, "key", {
          get: S,
          configurable: !0
        });
      }
    }
    function Lr(c, b) {
      {
        var S = function() {
          Kt || (Kt = !0, x("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", b));
        };
        S.isReactWarning = !0, Object.defineProperty(c, "ref", {
          get: S,
          configurable: !0
        });
      }
    }
    var Nr = function(c, b, S, O, k, F, N) {
      var P = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: e,
        // Built-in properties that belong on the element
        type: c,
        key: b,
        ref: S,
        props: N,
        // Record the component responsible for creating this element.
        _owner: F
      };
      return P._store = {}, Object.defineProperty(P._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(P, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: O
      }), Object.defineProperty(P, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: k
      }), Object.freeze && (Object.freeze(P.props), Object.freeze(P)), P;
    };
    function kr(c, b, S, O, k) {
      {
        var F, N = {}, P = null, H = null;
        S !== void 0 && (qt(S), P = "" + S), Tr(b) && (qt(b.key), P = "" + b.key), Ar(b) && (H = b.ref, Cr(b, k));
        for (F in b)
          Se.call(b, F) && !Or.hasOwnProperty(F) && (N[F] = b[F]);
        if (c && c.defaultProps) {
          var I = c.defaultProps;
          for (F in I)
            N[F] === void 0 && (N[F] = I[F]);
        }
        if (P || H) {
          var j = typeof c == "function" ? c.displayName || c.name || "Unknown" : c;
          P && Pr(N, j), H && Lr(N, j);
        }
        return Nr(c, P, H, k, O, xe.current, N);
      }
    }
    var lt = v.ReactCurrentOwner, Jt = v.ReactDebugCurrentFrame;
    function fe(c) {
      if (c) {
        var b = c._owner, S = Ue(c.type, c._source, b ? b.type : null);
        Jt.setExtraStackFrame(S);
      } else
        Jt.setExtraStackFrame(null);
    }
    var ct;
    ct = !1;
    function ft(c) {
      return typeof c == "object" && c !== null && c.$$typeof === e;
    }
    function Gt() {
      {
        if (lt.current) {
          var c = G(lt.current.type);
          if (c)
            return `

Check the render method of \`` + c + "`.";
        }
        return "";
      }
    }
    function $r(c) {
      return "";
    }
    var Wt = {};
    function Fr(c) {
      {
        var b = Gt();
        if (!b) {
          var S = typeof c == "string" ? c : c.displayName || c.name;
          S && (b = `

Check the top-level render call using <` + S + ">.");
        }
        return b;
      }
    }
    function Yt(c, b) {
      {
        if (!c._store || c._store.validated || c.key != null)
          return;
        c._store.validated = !0;
        var S = Fr(b);
        if (Wt[S])
          return;
        Wt[S] = !0;
        var O = "";
        c && c._owner && c._owner !== lt.current && (O = " It was passed a child from " + G(c._owner.type) + "."), fe(c), x('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', S, O), fe(null);
      }
    }
    function Qt(c, b) {
      {
        if (typeof c != "object")
          return;
        if (at(c))
          for (var S = 0; S < c.length; S++) {
            var O = c[S];
            ft(O) && Yt(O, b);
          }
        else if (ft(c))
          c._store && (c._store.validated = !0);
        else if (c) {
          var k = y(c);
          if (typeof k == "function" && k !== c.entries)
            for (var F = k.call(c), N; !(N = F.next()).done; )
              ft(N.value) && Yt(N.value, b);
        }
      }
    }
    function Ir(c) {
      {
        var b = c.type;
        if (b == null || typeof b == "string")
          return;
        var S;
        if (typeof b == "function")
          S = b.propTypes;
        else if (typeof b == "object" && (b.$$typeof === a || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        b.$$typeof === p))
          S = b.propTypes;
        else
          return;
        if (S) {
          var O = G(b);
          Sr(S, c.props, "prop", O, c);
        } else if (b.PropTypes !== void 0 && !ct) {
          ct = !0;
          var k = G(b);
          x("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", k || "Unknown");
        }
        typeof b.getDefaultProps == "function" && !b.getDefaultProps.isReactClassApproved && x("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Dr(c) {
      {
        for (var b = Object.keys(c.props), S = 0; S < b.length; S++) {
          var O = b[S];
          if (O !== "children" && O !== "key") {
            fe(c), x("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", O), fe(null);
            break;
          }
        }
        c.ref !== null && (fe(c), x("Invalid attribute `ref` supplied to `React.Fragment`."), fe(null));
      }
    }
    var Xt = {};
    function Zt(c, b, S, O, k, F) {
      {
        var N = De(c);
        if (!N) {
          var P = "";
          (c === void 0 || typeof c == "object" && c !== null && Object.keys(c).length === 0) && (P += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var H = $r();
          H ? P += H : P += Gt();
          var I;
          c === null ? I = "null" : at(c) ? I = "array" : c !== void 0 && c.$$typeof === e ? (I = "<" + (G(c.type) || "Unknown") + " />", P = " Did you accidentally export a JSX literal instead of a component?") : I = typeof c, x("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", I, P);
        }
        var j = kr(c, b, S, k, F);
        if (j == null)
          return j;
        if (N) {
          var W = b.children;
          if (W !== void 0)
            if (O)
              if (at(W)) {
                for (var de = 0; de < W.length; de++)
                  Qt(W[de], c);
                Object.freeze && Object.freeze(W);
              } else
                x("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Qt(W, c);
        }
        if (Se.call(b, "key")) {
          var ae = G(c), V = Object.keys(b).filter(function(Hr) {
            return Hr !== "key";
          }), dt = V.length > 0 ? "{key: someKey, " + V.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Xt[ae + dt]) {
            var Mr = V.length > 0 ? "{" + V.join(": ..., ") + ": ...}" : "{}";
            x(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, dt, ae, Mr, ae), Xt[ae + dt] = !0;
          }
        }
        return c === r ? Dr(j) : Ir(j), j;
      }
    }
    function jr(c, b, S) {
      return Zt(c, b, S, !0);
    }
    function _r(c, b, S) {
      return Zt(c, b, S, !1);
    }
    var Ur = _r, Br = jr;
    Re.Fragment = r, Re.jsx = Ur, Re.jsxs = Br;
  }()), Re;
}
process.env.NODE_ENV === "production" ? St.exports = Gr() : St.exports = Wr();
var Yr = St.exports;
function Qr() {
  if (console && console.warn) {
    for (var n = arguments.length, e = new Array(n), t = 0; t < n; t++)
      e[t] = arguments[t];
    typeof e[0] == "string" && (e[0] = `react-i18next:: ${e[0]}`), console.warn(...e);
  }
}
const rn = {};
function xt() {
  for (var n = arguments.length, e = new Array(n), t = 0; t < n; t++)
    e[t] = arguments[t];
  typeof e[0] == "string" && rn[e[0]] || (typeof e[0] == "string" && (rn[e[0]] = /* @__PURE__ */ new Date()), Qr(...e));
}
const jn = (n, e) => () => {
  if (n.isInitialized)
    e();
  else {
    const t = () => {
      setTimeout(() => {
        n.off("initialized", t);
      }, 0), e();
    };
    n.on("initialized", t);
  }
};
function sn(n, e, t) {
  n.loadNamespaces(e, jn(n, t));
}
function on(n, e, t, r) {
  typeof t == "string" && (t = [t]), t.forEach((s) => {
    n.options.ns.indexOf(s) < 0 && n.options.ns.push(s);
  }), n.loadLanguages(e, jn(n, r));
}
function Xr(n, e) {
  let t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  const r = e.languages[0], s = e.options ? e.options.fallbackLng : !1, i = e.languages[e.languages.length - 1];
  if (r.toLowerCase() === "cimode")
    return !0;
  const o = (u, a) => {
    const l = e.services.backendConnector.state[`${u}|${a}`];
    return l === -1 || l === 2;
  };
  return t.bindI18n && t.bindI18n.indexOf("languageChanging") > -1 && e.services.backendConnector.backend && e.isLanguageChangingTo && !o(e.isLanguageChangingTo, n) ? !1 : !!(e.hasResourceBundle(r, n) || !e.services.backendConnector.backend || e.options.resources && !e.options.partialBundledLanguages || o(r, n) && (!s || o(i, n)));
}
function Zr(n, e) {
  let t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  return !e.languages || !e.languages.length ? (xt("i18n.languages were undefined or empty", e.languages), !0) : e.options.ignoreJSONStructure !== void 0 ? e.hasLoadedNamespace(n, {
    lng: t.lng,
    precheck: (s, i) => {
      if (t.bindI18n && t.bindI18n.indexOf("languageChanging") > -1 && s.services.backendConnector.backend && s.isLanguageChangingTo && !i(s.isLanguageChangingTo, n))
        return !1;
    }
  }) : Xr(n, e, t);
}
const es = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g, ts = {
  "&amp;": "&",
  "&#38;": "&",
  "&lt;": "<",
  "&#60;": "<",
  "&gt;": ">",
  "&#62;": ">",
  "&apos;": "'",
  "&#39;": "'",
  "&quot;": '"',
  "&#34;": '"',
  "&nbsp;": " ",
  "&#160;": " ",
  "&copy;": "©",
  "&#169;": "©",
  "&reg;": "®",
  "&#174;": "®",
  "&hellip;": "…",
  "&#8230;": "…",
  "&#x2F;": "/",
  "&#47;": "/"
}, ns = (n) => ts[n], rs = (n) => n.replace(es, ns);
let Et = {
  bindI18n: "languageChanged",
  bindI18nStore: "",
  transEmptyNodeValue: "",
  transSupportBasicHtmlNodes: !0,
  transWrapTextNodes: "",
  transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p"],
  useSuspense: !0,
  unescape: rs
};
function ss() {
  let n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  Et = {
    ...Et,
    ...n
  };
}
function is() {
  return Et;
}
let _n;
function os(n) {
  _n = n;
}
function as() {
  return _n;
}
const us = {
  type: "3rdParty",
  init(n) {
    ss(n.options.react), os(n);
  }
}, Un = Vr();
class ls {
  constructor() {
    this.usedNamespaces = {};
  }
  addUsedNamespaces(e) {
    e.forEach((t) => {
      this.usedNamespaces[t] || (this.usedNamespaces[t] = !0);
    });
  }
  getUsedNamespaces() {
    return Object.keys(this.usedNamespaces);
  }
}
const cs = (n, e) => {
  const t = wt();
  return vt(() => {
    t.current = n;
  }, [n, e]), t.current;
};
function fs(n) {
  let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    i18n: t
  } = e, {
    i18n: r,
    defaultNS: s
  } = qr(Un) || {}, i = t || r || as();
  if (i && !i.reportNamespaces && (i.reportNamespaces = new ls()), !i) {
    xt("You will need to pass in an i18next instance by using initReactI18next");
    const E = (A, C) => typeof C == "string" ? C : C && typeof C == "object" && typeof C.defaultValue == "string" ? C.defaultValue : Array.isArray(A) ? A[A.length - 1] : A, R = [E, {}, !1];
    return R.t = E, R.i18n = {}, R.ready = !1, R;
  }
  i.options.react && i.options.react.wait !== void 0 && xt("It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
  const o = {
    ...is(),
    ...i.options.react,
    ...e
  }, {
    useSuspense: u,
    keyPrefix: a
  } = o;
  let l = n || s || i.options && i.options.defaultNS;
  l = typeof l == "string" ? [l] : l || ["translation"], i.reportNamespaces.addUsedNamespaces && i.reportNamespaces.addUsedNamespaces(l);
  const f = (i.isInitialized || i.initializedStoreOnce) && l.every((E) => Zr(E, i, o));
  function p() {
    return i.getFixedT(e.lng || null, o.nsMode === "fallback" ? l : l[0], a);
  }
  const [d, m] = zr(p);
  let h = l.join();
  e.lng && (h = `${e.lng}${h}`);
  const w = cs(h), y = wt(!0);
  vt(() => {
    const {
      bindI18n: E,
      bindI18nStore: R
    } = o;
    y.current = !0, !f && !u && (e.lng ? on(i, e.lng, l, () => {
      y.current && m(p);
    }) : sn(i, l, () => {
      y.current && m(p);
    })), f && w && w !== h && y.current && m(p);
    function A() {
      y.current && m(p);
    }
    return E && i && i.on(E, A), R && i && i.store.on(R, A), () => {
      y.current = !1, E && i && E.split(" ").forEach((C) => i.off(C, A)), R && i && R.split(" ").forEach((C) => i.store.off(C, A));
    };
  }, [i, h]);
  const v = wt(!0);
  vt(() => {
    y.current && !v.current && m(p), v.current = !1;
  }, [i, a]);
  const x = [d, i, f];
  if (x.t = d, x.i18n = i, x.ready = f, f || !f && !u)
    return x;
  throw new Promise((E) => {
    e.lng ? on(i, e.lng, l, () => E()) : sn(i, l, () => E());
  });
}
function ds(n) {
  let {
    i18n: e,
    defaultNS: t,
    children: r
  } = n;
  const s = Kr(() => ({
    i18n: e,
    defaultNS: t
  }), [e, t]);
  return Jr(Un.Provider, {
    value: s
  }, r);
}
const ps = "cropwise-language", hs = {
  type: "logger",
  log(n) {
    this.output("log", n);
  },
  warn(n) {
    this.output("warn", n);
  },
  error(n) {
    this.output("error", n);
  },
  output(n, e) {
    console && console[n] && console[n].apply(console, e);
  }
};
class qe {
  constructor(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.init(e, t);
  }
  init(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.prefix = t.prefix || "i18next:", this.logger = e || hs, this.options = t, this.debug = t.debug;
  }
  log() {
    for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
      t[r] = arguments[r];
    return this.forward(t, "log", "", !0);
  }
  warn() {
    for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
      t[r] = arguments[r];
    return this.forward(t, "warn", "", !0);
  }
  error() {
    for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
      t[r] = arguments[r];
    return this.forward(t, "error", "");
  }
  deprecate() {
    for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
      t[r] = arguments[r];
    return this.forward(t, "warn", "WARNING DEPRECATED: ", !0);
  }
  forward(e, t, r, s) {
    return s && !this.debug ? null : (typeof e[0] == "string" && (e[0] = `${r}${this.prefix} ${e[0]}`), this.logger[t](e));
  }
  create(e) {
    return new qe(this.logger, {
      prefix: `${this.prefix}:${e}:`,
      ...this.options
    });
  }
  clone(e) {
    return e = e || this.options, e.prefix = e.prefix || this.prefix, new qe(this.logger, e);
  }
}
var te = new qe();
class Qe {
  constructor() {
    this.observers = {};
  }
  on(e, t) {
    return e.split(" ").forEach((r) => {
      this.observers[r] || (this.observers[r] = /* @__PURE__ */ new Map());
      const s = this.observers[r].get(t) || 0;
      this.observers[r].set(t, s + 1);
    }), this;
  }
  off(e, t) {
    if (this.observers[e]) {
      if (!t) {
        delete this.observers[e];
        return;
      }
      this.observers[e].delete(t);
    }
  }
  emit(e) {
    for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), s = 1; s < t; s++)
      r[s - 1] = arguments[s];
    this.observers[e] && Array.from(this.observers[e].entries()).forEach((o) => {
      let [u, a] = o;
      for (let l = 0; l < a; l++)
        u(...r);
    }), this.observers["*"] && Array.from(this.observers["*"].entries()).forEach((o) => {
      let [u, a] = o;
      for (let l = 0; l < a; l++)
        u.apply(u, [e, ...r]);
    });
  }
}
const Oe = () => {
  let n, e;
  const t = new Promise((r, s) => {
    n = r, e = s;
  });
  return t.resolve = n, t.reject = e, t;
}, an = (n) => n == null ? "" : "" + n, gs = (n, e, t) => {
  n.forEach((r) => {
    e[r] && (t[r] = e[r]);
  });
}, ms = /###/g, un = (n) => n && n.indexOf("###") > -1 ? n.replace(ms, ".") : n, ln = (n) => !n || typeof n == "string", Le = (n, e, t) => {
  const r = typeof e != "string" ? e : e.split(".");
  let s = 0;
  for (; s < r.length - 1; ) {
    if (ln(n))
      return {};
    const i = un(r[s]);
    !n[i] && t && (n[i] = new t()), Object.prototype.hasOwnProperty.call(n, i) ? n = n[i] : n = {}, ++s;
  }
  return ln(n) ? {} : {
    obj: n,
    k: un(r[s])
  };
}, cn = (n, e, t) => {
  const {
    obj: r,
    k: s
  } = Le(n, e, Object);
  if (r !== void 0 || e.length === 1) {
    r[s] = t;
    return;
  }
  let i = e[e.length - 1], o = e.slice(0, e.length - 1), u = Le(n, o, Object);
  for (; u.obj === void 0 && o.length; )
    i = `${o[o.length - 1]}.${i}`, o = o.slice(0, o.length - 1), u = Le(n, o, Object), u && u.obj && typeof u.obj[`${u.k}.${i}`] < "u" && (u.obj = void 0);
  u.obj[`${u.k}.${i}`] = t;
}, ys = (n, e, t, r) => {
  const {
    obj: s,
    k: i
  } = Le(n, e, Object);
  s[i] = s[i] || [], s[i].push(t);
}, ze = (n, e) => {
  const {
    obj: t,
    k: r
  } = Le(n, e);
  if (t)
    return t[r];
}, bs = (n, e, t) => {
  const r = ze(n, t);
  return r !== void 0 ? r : ze(e, t);
}, Bn = (n, e, t) => {
  for (const r in e)
    r !== "__proto__" && r !== "constructor" && (r in n ? typeof n[r] == "string" || n[r] instanceof String || typeof e[r] == "string" || e[r] instanceof String ? t && (n[r] = e[r]) : Bn(n[r], e[r], t) : n[r] = e[r]);
  return n;
}, pe = (n) => n.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
var ws = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;"
};
const vs = (n) => typeof n == "string" ? n.replace(/[&<>"'\/]/g, (e) => ws[e]) : n;
class Ss {
  constructor(e) {
    this.capacity = e, this.regExpMap = /* @__PURE__ */ new Map(), this.regExpQueue = [];
  }
  getRegExp(e) {
    const t = this.regExpMap.get(e);
    if (t !== void 0)
      return t;
    const r = new RegExp(e);
    return this.regExpQueue.length === this.capacity && this.regExpMap.delete(this.regExpQueue.shift()), this.regExpMap.set(e, r), this.regExpQueue.push(e), r;
  }
}
const xs = [" ", ",", "?", "!", ";"], Es = new Ss(20), Rs = (n, e, t) => {
  e = e || "", t = t || "";
  const r = xs.filter((o) => e.indexOf(o) < 0 && t.indexOf(o) < 0);
  if (r.length === 0)
    return !0;
  const s = Es.getRegExp(`(${r.map((o) => o === "?" ? "\\?" : o).join("|")})`);
  let i = !s.test(n);
  if (!i) {
    const o = n.indexOf(t);
    o > 0 && !s.test(n.substring(0, o)) && (i = !0);
  }
  return i;
}, Rt = function(n, e) {
  let t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ".";
  if (!n)
    return;
  if (n[e])
    return n[e];
  const r = e.split(t);
  let s = n;
  for (let i = 0; i < r.length; ) {
    if (!s || typeof s != "object")
      return;
    let o, u = "";
    for (let a = i; a < r.length; ++a)
      if (a !== i && (u += t), u += r[a], o = s[u], o !== void 0) {
        if (["string", "number", "boolean"].indexOf(typeof o) > -1 && a < r.length - 1)
          continue;
        i += a - i + 1;
        break;
      }
    s = o;
  }
  return s;
}, Ke = (n) => n && n.indexOf("_") > 0 ? n.replace("_", "-") : n;
class fn extends Qe {
  constructor(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      ns: ["translation"],
      defaultNS: "translation"
    };
    super(), this.data = e || {}, this.options = t, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.options.ignoreJSONStructure === void 0 && (this.options.ignoreJSONStructure = !0);
  }
  addNamespaces(e) {
    this.options.ns.indexOf(e) < 0 && this.options.ns.push(e);
  }
  removeNamespaces(e) {
    const t = this.options.ns.indexOf(e);
    t > -1 && this.options.ns.splice(t, 1);
  }
  getResource(e, t, r) {
    let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const i = s.keySeparator !== void 0 ? s.keySeparator : this.options.keySeparator, o = s.ignoreJSONStructure !== void 0 ? s.ignoreJSONStructure : this.options.ignoreJSONStructure;
    let u;
    e.indexOf(".") > -1 ? u = e.split(".") : (u = [e, t], r && (Array.isArray(r) ? u.push(...r) : typeof r == "string" && i ? u.push(...r.split(i)) : u.push(r)));
    const a = ze(this.data, u);
    return !a && !t && !r && e.indexOf(".") > -1 && (e = u[0], t = u[1], r = u.slice(2).join(".")), a || !o || typeof r != "string" ? a : Rt(this.data && this.data[e] && this.data[e][t], r, i);
  }
  addResource(e, t, r, s) {
    let i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
      silent: !1
    };
    const o = i.keySeparator !== void 0 ? i.keySeparator : this.options.keySeparator;
    let u = [e, t];
    r && (u = u.concat(o ? r.split(o) : r)), e.indexOf(".") > -1 && (u = e.split("."), s = t, t = u[1]), this.addNamespaces(t), cn(this.data, u, s), i.silent || this.emit("added", e, t, r, s);
  }
  addResources(e, t, r) {
    let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
      silent: !1
    };
    for (const i in r)
      (typeof r[i] == "string" || Array.isArray(r[i])) && this.addResource(e, t, i, r[i], {
        silent: !0
      });
    s.silent || this.emit("added", e, t, r);
  }
  addResourceBundle(e, t, r, s, i) {
    let o = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {
      silent: !1,
      skipCopy: !1
    }, u = [e, t];
    e.indexOf(".") > -1 && (u = e.split("."), s = r, r = t, t = u[1]), this.addNamespaces(t);
    let a = ze(this.data, u) || {};
    o.skipCopy || (r = JSON.parse(JSON.stringify(r))), s ? Bn(a, r, i) : a = {
      ...a,
      ...r
    }, cn(this.data, u, a), o.silent || this.emit("added", e, t, r);
  }
  removeResourceBundle(e, t) {
    this.hasResourceBundle(e, t) && delete this.data[e][t], this.removeNamespaces(t), this.emit("removed", e, t);
  }
  hasResourceBundle(e, t) {
    return this.getResource(e, t) !== void 0;
  }
  getResourceBundle(e, t) {
    return t || (t = this.options.defaultNS), this.options.compatibilityAPI === "v1" ? {
      ...this.getResource(e, t)
    } : this.getResource(e, t);
  }
  getDataByLanguage(e) {
    return this.data[e];
  }
  hasLanguageSomeTranslations(e) {
    const t = this.getDataByLanguage(e);
    return !!(t && Object.keys(t) || []).find((s) => t[s] && Object.keys(t[s]).length > 0);
  }
  toJSON() {
    return this.data;
  }
}
var Mn = {
  processors: {},
  addPostProcessor(n) {
    this.processors[n.name] = n;
  },
  handle(n, e, t, r, s) {
    return n.forEach((i) => {
      this.processors[i] && (e = this.processors[i].process(e, t, r, s));
    }), e;
  }
};
const dn = {};
class Je extends Qe {
  constructor(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    super(), gs(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], e, this), this.options = t, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.logger = te.create("translator");
  }
  changeLanguage(e) {
    e && (this.language = e);
  }
  exists(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    };
    if (e == null)
      return !1;
    const r = this.resolve(e, t);
    return r && r.res !== void 0;
  }
  extractFromKey(e, t) {
    let r = t.nsSeparator !== void 0 ? t.nsSeparator : this.options.nsSeparator;
    r === void 0 && (r = ":");
    const s = t.keySeparator !== void 0 ? t.keySeparator : this.options.keySeparator;
    let i = t.ns || this.options.defaultNS || [];
    const o = r && e.indexOf(r) > -1, u = !this.options.userDefinedKeySeparator && !t.keySeparator && !this.options.userDefinedNsSeparator && !t.nsSeparator && !Rs(e, r, s);
    if (o && !u) {
      const a = e.match(this.interpolator.nestingRegexp);
      if (a && a.length > 0)
        return {
          key: e,
          namespaces: i
        };
      const l = e.split(r);
      (r !== s || r === s && this.options.ns.indexOf(l[0]) > -1) && (i = l.shift()), e = l.join(s);
    }
    return typeof i == "string" && (i = [i]), {
      key: e,
      namespaces: i
    };
  }
  translate(e, t, r) {
    if (typeof t != "object" && this.options.overloadTranslationOptionHandler && (t = this.options.overloadTranslationOptionHandler(arguments)), typeof t == "object" && (t = {
      ...t
    }), t || (t = {}), e == null)
      return "";
    Array.isArray(e) || (e = [String(e)]);
    const s = t.returnDetails !== void 0 ? t.returnDetails : this.options.returnDetails, i = t.keySeparator !== void 0 ? t.keySeparator : this.options.keySeparator, {
      key: o,
      namespaces: u
    } = this.extractFromKey(e[e.length - 1], t), a = u[u.length - 1], l = t.lng || this.language, f = t.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (l && l.toLowerCase() === "cimode") {
      if (f) {
        const R = t.nsSeparator || this.options.nsSeparator;
        return s ? {
          res: `${a}${R}${o}`,
          usedKey: o,
          exactUsedKey: o,
          usedLng: l,
          usedNS: a,
          usedParams: this.getUsedParamsDetails(t)
        } : `${a}${R}${o}`;
      }
      return s ? {
        res: o,
        usedKey: o,
        exactUsedKey: o,
        usedLng: l,
        usedNS: a,
        usedParams: this.getUsedParamsDetails(t)
      } : o;
    }
    const p = this.resolve(e, t);
    let d = p && p.res;
    const m = p && p.usedKey || o, h = p && p.exactUsedKey || o, w = Object.prototype.toString.apply(d), y = ["[object Number]", "[object Function]", "[object RegExp]"], v = t.joinArrays !== void 0 ? t.joinArrays : this.options.joinArrays, x = !this.i18nFormat || this.i18nFormat.handleAsObject;
    if (x && d && (typeof d != "string" && typeof d != "boolean" && typeof d != "number") && y.indexOf(w) < 0 && !(typeof v == "string" && Array.isArray(d))) {
      if (!t.returnObjects && !this.options.returnObjects) {
        this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!");
        const R = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(m, d, {
          ...t,
          ns: u
        }) : `key '${o} (${this.language})' returned an object instead of string.`;
        return s ? (p.res = R, p.usedParams = this.getUsedParamsDetails(t), p) : R;
      }
      if (i) {
        const R = Array.isArray(d), A = R ? [] : {}, C = R ? h : m;
        for (const L in d)
          if (Object.prototype.hasOwnProperty.call(d, L)) {
            const Q = `${C}${i}${L}`;
            A[L] = this.translate(Q, {
              ...t,
              joinArrays: !1,
              ns: u
            }), A[L] === Q && (A[L] = d[L]);
          }
        d = A;
      }
    } else if (x && typeof v == "string" && Array.isArray(d))
      d = d.join(v), d && (d = this.extendTranslation(d, e, t, r));
    else {
      let R = !1, A = !1;
      const C = t.count !== void 0 && typeof t.count != "string", L = Je.hasDefaultValue(t), Q = C ? this.pluralResolver.getSuffix(l, t.count, t) : "", se = t.ordinal && C ? this.pluralResolver.getSuffix(l, t.count, {
        ordinal: !1
      }) : "", De = C && !t.ordinal && t.count === 0 && this.pluralResolver.shouldUseIntlApi(), ie = De && t[`defaultValue${this.options.pluralSeparator}zero`] || t[`defaultValue${Q}`] || t[`defaultValue${se}`] || t.defaultValue;
      !this.isValidLookup(d) && L && (R = !0, d = ie), this.isValidLookup(d) || (A = !0, d = o);
      const G = (t.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey) && A ? void 0 : d, K = L && ie !== d && this.options.updateMissing;
      if (A || R || K) {
        if (this.logger.log(K ? "updateKey" : "missingKey", l, a, o, K ? ie : d), i) {
          const B = this.resolve(o, {
            ...t,
            keySeparator: !1
          });
          B && B.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
        }
        let X = [];
        const oe = this.languageUtils.getFallbackCodes(this.options.fallbackLng, t.lng || this.language);
        if (this.options.saveMissingTo === "fallback" && oe && oe[0])
          for (let B = 0; B < oe.length; B++)
            X.push(oe[B]);
        else
          this.options.saveMissingTo === "all" ? X = this.languageUtils.toResolveHierarchy(t.lng || this.language) : X.push(t.lng || this.language);
        const we = (B, ee, ne) => {
          const ve = L && ne !== d ? ne : G;
          this.options.missingKeyHandler ? this.options.missingKeyHandler(B, a, ee, ve, K, t) : this.backendConnector && this.backendConnector.saveMissing && this.backendConnector.saveMissing(B, a, ee, ve, K, t), this.emit("missingKey", B, a, ee, d);
        };
        this.options.saveMissing && (this.options.saveMissingPlurals && C ? X.forEach((B) => {
          const ee = this.pluralResolver.getSuffixes(B, t);
          De && t[`defaultValue${this.options.pluralSeparator}zero`] && ee.indexOf(`${this.options.pluralSeparator}zero`) < 0 && ee.push(`${this.options.pluralSeparator}zero`), ee.forEach((ne) => {
            we([B], o + ne, t[`defaultValue${ne}`] || ie);
          });
        }) : we(X, o, ie));
      }
      d = this.extendTranslation(d, e, t, p, r), A && d === o && this.options.appendNamespaceToMissingKey && (d = `${a}:${o}`), (A || R) && this.options.parseMissingKeyHandler && (this.options.compatibilityAPI !== "v1" ? d = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${a}:${o}` : o, R ? d : void 0) : d = this.options.parseMissingKeyHandler(d));
    }
    return s ? (p.res = d, p.usedParams = this.getUsedParamsDetails(t), p) : d;
  }
  extendTranslation(e, t, r, s, i) {
    var o = this;
    if (this.i18nFormat && this.i18nFormat.parse)
      e = this.i18nFormat.parse(e, {
        ...this.options.interpolation.defaultVariables,
        ...r
      }, r.lng || this.language || s.usedLng, s.usedNS, s.usedKey, {
        resolved: s
      });
    else if (!r.skipInterpolation) {
      r.interpolation && this.interpolator.init({
        ...r,
        interpolation: {
          ...this.options.interpolation,
          ...r.interpolation
        }
      });
      const l = typeof e == "string" && (r && r.interpolation && r.interpolation.skipOnVariables !== void 0 ? r.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
      let f;
      if (l) {
        const d = e.match(this.interpolator.nestingRegexp);
        f = d && d.length;
      }
      let p = r.replace && typeof r.replace != "string" ? r.replace : r;
      if (this.options.interpolation.defaultVariables && (p = {
        ...this.options.interpolation.defaultVariables,
        ...p
      }), e = this.interpolator.interpolate(e, p, r.lng || this.language || s.usedLng, r), l) {
        const d = e.match(this.interpolator.nestingRegexp), m = d && d.length;
        f < m && (r.nest = !1);
      }
      !r.lng && this.options.compatibilityAPI !== "v1" && s && s.res && (r.lng = this.language || s.usedLng), r.nest !== !1 && (e = this.interpolator.nest(e, function() {
        for (var d = arguments.length, m = new Array(d), h = 0; h < d; h++)
          m[h] = arguments[h];
        return i && i[0] === m[0] && !r.context ? (o.logger.warn(`It seems you are nesting recursively key: ${m[0]} in key: ${t[0]}`), null) : o.translate(...m, t);
      }, r)), r.interpolation && this.interpolator.reset();
    }
    const u = r.postProcess || this.options.postProcess, a = typeof u == "string" ? [u] : u;
    return e != null && a && a.length && r.applyPostProcessor !== !1 && (e = Mn.handle(a, e, t, this.options && this.options.postProcessPassResolved ? {
      i18nResolved: {
        ...s,
        usedParams: this.getUsedParamsDetails(r)
      },
      ...r
    } : r, this)), e;
  }
  resolve(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r, s, i, o, u;
    return typeof e == "string" && (e = [e]), e.forEach((a) => {
      if (this.isValidLookup(r))
        return;
      const l = this.extractFromKey(a, t), f = l.key;
      s = f;
      let p = l.namespaces;
      this.options.fallbackNS && (p = p.concat(this.options.fallbackNS));
      const d = t.count !== void 0 && typeof t.count != "string", m = d && !t.ordinal && t.count === 0 && this.pluralResolver.shouldUseIntlApi(), h = t.context !== void 0 && (typeof t.context == "string" || typeof t.context == "number") && t.context !== "", w = t.lngs ? t.lngs : this.languageUtils.toResolveHierarchy(t.lng || this.language, t.fallbackLng);
      p.forEach((y) => {
        this.isValidLookup(r) || (u = y, !dn[`${w[0]}-${y}`] && this.utils && this.utils.hasLoadedNamespace && !this.utils.hasLoadedNamespace(u) && (dn[`${w[0]}-${y}`] = !0, this.logger.warn(`key "${s}" for languages "${w.join(", ")}" won't get resolved as namespace "${u}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), w.forEach((v) => {
          if (this.isValidLookup(r))
            return;
          o = v;
          const x = [f];
          if (this.i18nFormat && this.i18nFormat.addLookupKeys)
            this.i18nFormat.addLookupKeys(x, f, v, y, t);
          else {
            let R;
            d && (R = this.pluralResolver.getSuffix(v, t.count, t));
            const A = `${this.options.pluralSeparator}zero`, C = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
            if (d && (x.push(f + R), t.ordinal && R.indexOf(C) === 0 && x.push(f + R.replace(C, this.options.pluralSeparator)), m && x.push(f + A)), h) {
              const L = `${f}${this.options.contextSeparator}${t.context}`;
              x.push(L), d && (x.push(L + R), t.ordinal && R.indexOf(C) === 0 && x.push(L + R.replace(C, this.options.pluralSeparator)), m && x.push(L + A));
            }
          }
          let E;
          for (; E = x.pop(); )
            this.isValidLookup(r) || (i = E, r = this.getResource(v, y, E, t));
        }));
      });
    }), {
      res: r,
      usedKey: s,
      exactUsedKey: i,
      usedLng: o,
      usedNS: u
    };
  }
  isValidLookup(e) {
    return e !== void 0 && !(!this.options.returnNull && e === null) && !(!this.options.returnEmptyString && e === "");
  }
  getResource(e, t, r) {
    let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return this.i18nFormat && this.i18nFormat.getResource ? this.i18nFormat.getResource(e, t, r, s) : this.resourceStore.getResource(e, t, r, s);
  }
  getUsedParamsDetails() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const t = ["defaultValue", "ordinal", "context", "replace", "lng", "lngs", "fallbackLng", "ns", "keySeparator", "nsSeparator", "returnObjects", "returnDetails", "joinArrays", "postProcess", "interpolation"], r = e.replace && typeof e.replace != "string";
    let s = r ? e.replace : e;
    if (r && typeof e.count < "u" && (s.count = e.count), this.options.interpolation.defaultVariables && (s = {
      ...this.options.interpolation.defaultVariables,
      ...s
    }), !r) {
      s = {
        ...s
      };
      for (const i of t)
        delete s[i];
    }
    return s;
  }
  static hasDefaultValue(e) {
    const t = "defaultValue";
    for (const r in e)
      if (Object.prototype.hasOwnProperty.call(e, r) && t === r.substring(0, t.length) && e[r] !== void 0)
        return !0;
    return !1;
  }
}
const pt = (n) => n.charAt(0).toUpperCase() + n.slice(1);
class pn {
  constructor(e) {
    this.options = e, this.supportedLngs = this.options.supportedLngs || !1, this.logger = te.create("languageUtils");
  }
  getScriptPartFromCode(e) {
    if (e = Ke(e), !e || e.indexOf("-") < 0)
      return null;
    const t = e.split("-");
    return t.length === 2 || (t.pop(), t[t.length - 1].toLowerCase() === "x") ? null : this.formatLanguageCode(t.join("-"));
  }
  getLanguagePartFromCode(e) {
    if (e = Ke(e), !e || e.indexOf("-") < 0)
      return e;
    const t = e.split("-");
    return this.formatLanguageCode(t[0]);
  }
  formatLanguageCode(e) {
    if (typeof e == "string" && e.indexOf("-") > -1) {
      const t = ["hans", "hant", "latn", "cyrl", "cans", "mong", "arab"];
      let r = e.split("-");
      return this.options.lowerCaseLng ? r = r.map((s) => s.toLowerCase()) : r.length === 2 ? (r[0] = r[0].toLowerCase(), r[1] = r[1].toUpperCase(), t.indexOf(r[1].toLowerCase()) > -1 && (r[1] = pt(r[1].toLowerCase()))) : r.length === 3 && (r[0] = r[0].toLowerCase(), r[1].length === 2 && (r[1] = r[1].toUpperCase()), r[0] !== "sgn" && r[2].length === 2 && (r[2] = r[2].toUpperCase()), t.indexOf(r[1].toLowerCase()) > -1 && (r[1] = pt(r[1].toLowerCase())), t.indexOf(r[2].toLowerCase()) > -1 && (r[2] = pt(r[2].toLowerCase()))), r.join("-");
    }
    return this.options.cleanCode || this.options.lowerCaseLng ? e.toLowerCase() : e;
  }
  isSupportedCode(e) {
    return (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) && (e = this.getLanguagePartFromCode(e)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(e) > -1;
  }
  getBestMatchFromCodes(e) {
    if (!e)
      return null;
    let t;
    return e.forEach((r) => {
      if (t)
        return;
      const s = this.formatLanguageCode(r);
      (!this.options.supportedLngs || this.isSupportedCode(s)) && (t = s);
    }), !t && this.options.supportedLngs && e.forEach((r) => {
      if (t)
        return;
      const s = this.getLanguagePartFromCode(r);
      if (this.isSupportedCode(s))
        return t = s;
      t = this.options.supportedLngs.find((i) => {
        if (i === s)
          return i;
        if (!(i.indexOf("-") < 0 && s.indexOf("-") < 0) && (i.indexOf("-") > 0 && s.indexOf("-") < 0 && i.substring(0, i.indexOf("-")) === s || i.indexOf(s) === 0 && s.length > 1))
          return i;
      });
    }), t || (t = this.getFallbackCodes(this.options.fallbackLng)[0]), t;
  }
  getFallbackCodes(e, t) {
    if (!e)
      return [];
    if (typeof e == "function" && (e = e(t)), typeof e == "string" && (e = [e]), Array.isArray(e))
      return e;
    if (!t)
      return e.default || [];
    let r = e[t];
    return r || (r = e[this.getScriptPartFromCode(t)]), r || (r = e[this.formatLanguageCode(t)]), r || (r = e[this.getLanguagePartFromCode(t)]), r || (r = e.default), r || [];
  }
  toResolveHierarchy(e, t) {
    const r = this.getFallbackCodes(t || this.options.fallbackLng || [], e), s = [], i = (o) => {
      o && (this.isSupportedCode(o) ? s.push(o) : this.logger.warn(`rejecting language code not found in supportedLngs: ${o}`));
    };
    return typeof e == "string" && (e.indexOf("-") > -1 || e.indexOf("_") > -1) ? (this.options.load !== "languageOnly" && i(this.formatLanguageCode(e)), this.options.load !== "languageOnly" && this.options.load !== "currentOnly" && i(this.getScriptPartFromCode(e)), this.options.load !== "currentOnly" && i(this.getLanguagePartFromCode(e))) : typeof e == "string" && i(this.formatLanguageCode(e)), r.forEach((o) => {
      s.indexOf(o) < 0 && i(this.formatLanguageCode(o));
    }), s;
  }
}
let Os = [{
  lngs: ["ach", "ak", "am", "arn", "br", "fil", "gun", "ln", "mfe", "mg", "mi", "oc", "pt", "pt-BR", "tg", "tl", "ti", "tr", "uz", "wa"],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ["af", "an", "ast", "az", "bg", "bn", "ca", "da", "de", "dev", "el", "en", "eo", "es", "et", "eu", "fi", "fo", "fur", "fy", "gl", "gu", "ha", "hi", "hu", "hy", "ia", "it", "kk", "kn", "ku", "lb", "mai", "ml", "mn", "mr", "nah", "nap", "nb", "ne", "nl", "nn", "no", "nso", "pa", "pap", "pms", "ps", "pt-PT", "rm", "sco", "se", "si", "so", "son", "sq", "sv", "sw", "ta", "te", "tk", "ur", "yo"],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ["ay", "bo", "cgg", "fa", "ht", "id", "ja", "jbo", "ka", "km", "ko", "ky", "lo", "ms", "sah", "su", "th", "tt", "ug", "vi", "wo", "zh"],
  nr: [1],
  fc: 3
}, {
  lngs: ["be", "bs", "cnr", "dz", "hr", "ru", "sr", "uk"],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ["ar"],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ["cs", "sk"],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ["csb", "pl"],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ["cy"],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ["fr"],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ["ga"],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ["gd"],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ["is"],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ["jv"],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ["kw"],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ["lt"],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ["lv"],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ["mk"],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ["mnk"],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ["mt"],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ["or"],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ["ro"],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ["sl"],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ["he", "iw"],
  nr: [1, 2, 20, 21],
  fc: 22
}], As = {
  1: (n) => +(n > 1),
  2: (n) => +(n != 1),
  3: (n) => 0,
  4: (n) => n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2,
  5: (n) => n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5,
  6: (n) => n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2,
  7: (n) => n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2,
  8: (n) => n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3,
  9: (n) => +(n >= 2),
  10: (n) => n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4,
  11: (n) => n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3,
  12: (n) => +(n % 10 != 1 || n % 100 == 11),
  13: (n) => +(n !== 0),
  14: (n) => n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3,
  15: (n) => n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2,
  16: (n) => n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2,
  17: (n) => n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1,
  18: (n) => n == 0 ? 0 : n == 1 ? 1 : 2,
  19: (n) => n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3,
  20: (n) => n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2,
  21: (n) => n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0,
  22: (n) => n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3
};
const Ts = ["v1", "v2", "v3"], Cs = ["v4"], hn = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
}, Ps = () => {
  const n = {};
  return Os.forEach((e) => {
    e.lngs.forEach((t) => {
      n[t] = {
        numbers: e.nr,
        plurals: As[e.fc]
      };
    });
  }), n;
};
class Ls {
  constructor(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.languageUtils = e, this.options = t, this.logger = te.create("pluralResolver"), (!this.options.compatibilityJSON || Cs.includes(this.options.compatibilityJSON)) && (typeof Intl > "u" || !Intl.PluralRules) && (this.options.compatibilityJSON = "v3", this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.")), this.rules = Ps(), this.pluralRulesCache = {};
  }
  addRule(e, t) {
    this.rules[e] = t;
  }
  clearCache() {
    this.pluralRulesCache = {};
  }
  getRule(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (this.shouldUseIntlApi())
      try {
        const r = Ke(e === "dev" ? "en" : e), s = t.ordinal ? "ordinal" : "cardinal", i = JSON.stringify({
          cleanedCode: r,
          type: s
        });
        if (i in this.pluralRulesCache)
          return this.pluralRulesCache[i];
        const o = new Intl.PluralRules(r, {
          type: s
        });
        return this.pluralRulesCache[i] = o, o;
      } catch {
        return;
      }
    return this.rules[e] || this.rules[this.languageUtils.getLanguagePartFromCode(e)];
  }
  needsPlural(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const r = this.getRule(e, t);
    return this.shouldUseIntlApi() ? r && r.resolvedOptions().pluralCategories.length > 1 : r && r.numbers.length > 1;
  }
  getPluralFormsOfKey(e, t) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return this.getSuffixes(e, r).map((s) => `${t}${s}`);
  }
  getSuffixes(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const r = this.getRule(e, t);
    return r ? this.shouldUseIntlApi() ? r.resolvedOptions().pluralCategories.sort((s, i) => hn[s] - hn[i]).map((s) => `${this.options.prepend}${t.ordinal ? `ordinal${this.options.prepend}` : ""}${s}`) : r.numbers.map((s) => this.getSuffix(e, s, t)) : [];
  }
  getSuffix(e, t) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const s = this.getRule(e, r);
    return s ? this.shouldUseIntlApi() ? `${this.options.prepend}${r.ordinal ? `ordinal${this.options.prepend}` : ""}${s.select(t)}` : this.getSuffixRetroCompatible(s, t) : (this.logger.warn(`no plural rule found for: ${e}`), "");
  }
  getSuffixRetroCompatible(e, t) {
    const r = e.noAbs ? e.plurals(t) : e.plurals(Math.abs(t));
    let s = e.numbers[r];
    this.options.simplifyPluralSuffix && e.numbers.length === 2 && e.numbers[0] === 1 && (s === 2 ? s = "plural" : s === 1 && (s = ""));
    const i = () => this.options.prepend && s.toString() ? this.options.prepend + s.toString() : s.toString();
    return this.options.compatibilityJSON === "v1" ? s === 1 ? "" : typeof s == "number" ? `_plural_${s.toString()}` : i() : this.options.compatibilityJSON === "v2" || this.options.simplifyPluralSuffix && e.numbers.length === 2 && e.numbers[0] === 1 ? i() : this.options.prepend && r.toString() ? this.options.prepend + r.toString() : r.toString();
  }
  shouldUseIntlApi() {
    return !Ts.includes(this.options.compatibilityJSON);
  }
}
const gn = function(n, e, t) {
  let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ".", s = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !0, i = bs(n, e, t);
  return !i && s && typeof t == "string" && (i = Rt(n, t, r), i === void 0 && (i = Rt(e, t, r))), i;
}, ht = (n) => n.replace(/\$/g, "$$$$");
class Ns {
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = te.create("interpolator"), this.options = e, this.format = e.interpolation && e.interpolation.format || ((t) => t), this.init(e);
  }
  init() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    e.interpolation || (e.interpolation = {
      escapeValue: !0
    });
    const {
      escape: t,
      escapeValue: r,
      useRawValueToEscape: s,
      prefix: i,
      prefixEscaped: o,
      suffix: u,
      suffixEscaped: a,
      formatSeparator: l,
      unescapeSuffix: f,
      unescapePrefix: p,
      nestingPrefix: d,
      nestingPrefixEscaped: m,
      nestingSuffix: h,
      nestingSuffixEscaped: w,
      nestingOptionsSeparator: y,
      maxReplaces: v,
      alwaysFormat: x
    } = e.interpolation;
    this.escape = t !== void 0 ? t : vs, this.escapeValue = r !== void 0 ? r : !0, this.useRawValueToEscape = s !== void 0 ? s : !1, this.prefix = i ? pe(i) : o || "{{", this.suffix = u ? pe(u) : a || "}}", this.formatSeparator = l || ",", this.unescapePrefix = f ? "" : p || "-", this.unescapeSuffix = this.unescapePrefix ? "" : f || "", this.nestingPrefix = d ? pe(d) : m || pe("$t("), this.nestingSuffix = h ? pe(h) : w || pe(")"), this.nestingOptionsSeparator = y || ",", this.maxReplaces = v || 1e3, this.alwaysFormat = x !== void 0 ? x : !1, this.resetRegExp();
  }
  reset() {
    this.options && this.init(this.options);
  }
  resetRegExp() {
    const e = (t, r) => t && t.source === r ? (t.lastIndex = 0, t) : new RegExp(r, "g");
    this.regexp = e(this.regexp, `${this.prefix}(.+?)${this.suffix}`), this.regexpUnescape = e(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`), this.nestingRegexp = e(this.nestingRegexp, `${this.nestingPrefix}(.+?)${this.nestingSuffix}`);
  }
  interpolate(e, t, r, s) {
    let i, o, u;
    const a = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {}, l = (m) => {
      if (m.indexOf(this.formatSeparator) < 0) {
        const v = gn(t, a, m, this.options.keySeparator, this.options.ignoreJSONStructure);
        return this.alwaysFormat ? this.format(v, void 0, r, {
          ...s,
          ...t,
          interpolationkey: m
        }) : v;
      }
      const h = m.split(this.formatSeparator), w = h.shift().trim(), y = h.join(this.formatSeparator).trim();
      return this.format(gn(t, a, w, this.options.keySeparator, this.options.ignoreJSONStructure), y, r, {
        ...s,
        ...t,
        interpolationkey: w
      });
    };
    this.resetRegExp();
    const f = s && s.missingInterpolationHandler || this.options.missingInterpolationHandler, p = s && s.interpolation && s.interpolation.skipOnVariables !== void 0 ? s.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
    return [{
      regex: this.regexpUnescape,
      safeValue: (m) => ht(m)
    }, {
      regex: this.regexp,
      safeValue: (m) => this.escapeValue ? ht(this.escape(m)) : ht(m)
    }].forEach((m) => {
      for (u = 0; i = m.regex.exec(e); ) {
        const h = i[1].trim();
        if (o = l(h), o === void 0)
          if (typeof f == "function") {
            const y = f(e, i, s);
            o = typeof y == "string" ? y : "";
          } else if (s && Object.prototype.hasOwnProperty.call(s, h))
            o = "";
          else if (p) {
            o = i[0];
            continue;
          } else
            this.logger.warn(`missed to pass in variable ${h} for interpolating ${e}`), o = "";
        else
          typeof o != "string" && !this.useRawValueToEscape && (o = an(o));
        const w = m.safeValue(o);
        if (e = e.replace(i[0], w), p ? (m.regex.lastIndex += o.length, m.regex.lastIndex -= i[0].length) : m.regex.lastIndex = 0, u++, u >= this.maxReplaces)
          break;
      }
    }), e;
  }
  nest(e, t) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, s, i, o;
    const u = (a, l) => {
      const f = this.nestingOptionsSeparator;
      if (a.indexOf(f) < 0)
        return a;
      const p = a.split(new RegExp(`${f}[ ]*{`));
      let d = `{${p[1]}`;
      a = p[0], d = this.interpolate(d, o);
      const m = d.match(/'/g), h = d.match(/"/g);
      (m && m.length % 2 === 0 && !h || h.length % 2 !== 0) && (d = d.replace(/'/g, '"'));
      try {
        o = JSON.parse(d), l && (o = {
          ...l,
          ...o
        });
      } catch (w) {
        return this.logger.warn(`failed parsing options string in nesting for key ${a}`, w), `${a}${f}${d}`;
      }
      return o.defaultValue && o.defaultValue.indexOf(this.prefix) > -1 && delete o.defaultValue, a;
    };
    for (; s = this.nestingRegexp.exec(e); ) {
      let a = [];
      o = {
        ...r
      }, o = o.replace && typeof o.replace != "string" ? o.replace : o, o.applyPostProcessor = !1, delete o.defaultValue;
      let l = !1;
      if (s[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(s[1])) {
        const f = s[1].split(this.formatSeparator).map((p) => p.trim());
        s[1] = f.shift(), a = f, l = !0;
      }
      if (i = t(u.call(this, s[1].trim(), o), o), i && s[0] === e && typeof i != "string")
        return i;
      typeof i != "string" && (i = an(i)), i || (this.logger.warn(`missed to resolve ${s[1]} for nesting ${e}`), i = ""), l && (i = a.reduce((f, p) => this.format(f, p, r.lng, {
        ...r,
        interpolationkey: s[1].trim()
      }), i.trim())), e = e.replace(s[0], i), this.regexp.lastIndex = 0;
    }
    return e;
  }
}
const ks = (n) => {
  let e = n.toLowerCase().trim();
  const t = {};
  if (n.indexOf("(") > -1) {
    const r = n.split("(");
    e = r[0].toLowerCase().trim();
    const s = r[1].substring(0, r[1].length - 1);
    e === "currency" && s.indexOf(":") < 0 ? t.currency || (t.currency = s.trim()) : e === "relativetime" && s.indexOf(":") < 0 ? t.range || (t.range = s.trim()) : s.split(";").forEach((o) => {
      if (o) {
        const [u, ...a] = o.split(":"), l = a.join(":").trim().replace(/^'+|'+$/g, ""), f = u.trim();
        t[f] || (t[f] = l), l === "false" && (t[f] = !1), l === "true" && (t[f] = !0), isNaN(l) || (t[f] = parseInt(l, 10));
      }
    });
  }
  return {
    formatName: e,
    formatOptions: t
  };
}, he = (n) => {
  const e = {};
  return (t, r, s) => {
    let i = s;
    s && s.interpolationkey && s.formatParams && s.formatParams[s.interpolationkey] && s[s.interpolationkey] && (i = {
      ...i,
      [s.interpolationkey]: void 0
    });
    const o = r + JSON.stringify(i);
    let u = e[o];
    return u || (u = n(Ke(r), s), e[o] = u), u(t);
  };
};
class $s {
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = te.create("formatter"), this.options = e, this.formats = {
      number: he((t, r) => {
        const s = new Intl.NumberFormat(t, {
          ...r
        });
        return (i) => s.format(i);
      }),
      currency: he((t, r) => {
        const s = new Intl.NumberFormat(t, {
          ...r,
          style: "currency"
        });
        return (i) => s.format(i);
      }),
      datetime: he((t, r) => {
        const s = new Intl.DateTimeFormat(t, {
          ...r
        });
        return (i) => s.format(i);
      }),
      relativetime: he((t, r) => {
        const s = new Intl.RelativeTimeFormat(t, {
          ...r
        });
        return (i) => s.format(i, r.range || "day");
      }),
      list: he((t, r) => {
        const s = new Intl.ListFormat(t, {
          ...r
        });
        return (i) => s.format(i);
      })
    }, this.init(e);
  }
  init(e) {
    const r = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    }).interpolation;
    this.formatSeparator = r.formatSeparator ? r.formatSeparator : r.formatSeparator || ",";
  }
  add(e, t) {
    this.formats[e.toLowerCase().trim()] = t;
  }
  addCached(e, t) {
    this.formats[e.toLowerCase().trim()] = he(t);
  }
  format(e, t, r) {
    let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const i = t.split(this.formatSeparator);
    if (i.length > 1 && i[0].indexOf("(") > 1 && i[0].indexOf(")") < 0 && i.find((u) => u.indexOf(")") > -1)) {
      const u = i.findIndex((a) => a.indexOf(")") > -1);
      i[0] = [i[0], ...i.splice(1, u)].join(this.formatSeparator);
    }
    return i.reduce((u, a) => {
      const {
        formatName: l,
        formatOptions: f
      } = ks(a);
      if (this.formats[l]) {
        let p = u;
        try {
          const d = s && s.formatParams && s.formatParams[s.interpolationkey] || {}, m = d.locale || d.lng || s.locale || s.lng || r;
          p = this.formats[l](u, m, {
            ...f,
            ...s,
            ...d
          });
        } catch (d) {
          this.logger.warn(d);
        }
        return p;
      } else
        this.logger.warn(`there was no format function for ${l}`);
      return u;
    }, e);
  }
}
const Fs = (n, e) => {
  n.pending[e] !== void 0 && (delete n.pending[e], n.pendingCount--);
};
class Is extends Qe {
  constructor(e, t, r) {
    let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    super(), this.backend = e, this.store = t, this.services = r, this.languageUtils = r.languageUtils, this.options = s, this.logger = te.create("backendConnector"), this.waitingReads = [], this.maxParallelReads = s.maxParallelReads || 10, this.readingCalls = 0, this.maxRetries = s.maxRetries >= 0 ? s.maxRetries : 5, this.retryTimeout = s.retryTimeout >= 1 ? s.retryTimeout : 350, this.state = {}, this.queue = [], this.backend && this.backend.init && this.backend.init(r, s.backend, s);
  }
  queueLoad(e, t, r, s) {
    const i = {}, o = {}, u = {}, a = {};
    return e.forEach((l) => {
      let f = !0;
      t.forEach((p) => {
        const d = `${l}|${p}`;
        !r.reload && this.store.hasResourceBundle(l, p) ? this.state[d] = 2 : this.state[d] < 0 || (this.state[d] === 1 ? o[d] === void 0 && (o[d] = !0) : (this.state[d] = 1, f = !1, o[d] === void 0 && (o[d] = !0), i[d] === void 0 && (i[d] = !0), a[p] === void 0 && (a[p] = !0)));
      }), f || (u[l] = !0);
    }), (Object.keys(i).length || Object.keys(o).length) && this.queue.push({
      pending: o,
      pendingCount: Object.keys(o).length,
      loaded: {},
      errors: [],
      callback: s
    }), {
      toLoad: Object.keys(i),
      pending: Object.keys(o),
      toLoadLanguages: Object.keys(u),
      toLoadNamespaces: Object.keys(a)
    };
  }
  loaded(e, t, r) {
    const s = e.split("|"), i = s[0], o = s[1];
    t && this.emit("failedLoading", i, o, t), !t && r && this.store.addResourceBundle(i, o, r, void 0, void 0, {
      skipCopy: !0
    }), this.state[e] = t ? -1 : 2, t && r && (this.state[e] = 0);
    const u = {};
    this.queue.forEach((a) => {
      ys(a.loaded, [i], o), Fs(a, e), t && a.errors.push(t), a.pendingCount === 0 && !a.done && (Object.keys(a.loaded).forEach((l) => {
        u[l] || (u[l] = {});
        const f = a.loaded[l];
        f.length && f.forEach((p) => {
          u[l][p] === void 0 && (u[l][p] = !0);
        });
      }), a.done = !0, a.errors.length ? a.callback(a.errors) : a.callback());
    }), this.emit("loaded", u), this.queue = this.queue.filter((a) => !a.done);
  }
  read(e, t, r) {
    let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : this.retryTimeout, o = arguments.length > 5 ? arguments[5] : void 0;
    if (!e.length)
      return o(null, {});
    if (this.readingCalls >= this.maxParallelReads) {
      this.waitingReads.push({
        lng: e,
        ns: t,
        fcName: r,
        tried: s,
        wait: i,
        callback: o
      });
      return;
    }
    this.readingCalls++;
    const u = (l, f) => {
      if (this.readingCalls--, this.waitingReads.length > 0) {
        const p = this.waitingReads.shift();
        this.read(p.lng, p.ns, p.fcName, p.tried, p.wait, p.callback);
      }
      if (l && f && s < this.maxRetries) {
        setTimeout(() => {
          this.read.call(this, e, t, r, s + 1, i * 2, o);
        }, i);
        return;
      }
      o(l, f);
    }, a = this.backend[r].bind(this.backend);
    if (a.length === 2) {
      try {
        const l = a(e, t);
        l && typeof l.then == "function" ? l.then((f) => u(null, f)).catch(u) : u(null, l);
      } catch (l) {
        u(l);
      }
      return;
    }
    return a(e, t, u);
  }
  prepareLoading(e, t) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, s = arguments.length > 3 ? arguments[3] : void 0;
    if (!this.backend)
      return this.logger.warn("No backend was added via i18next.use. Will not load resources."), s && s();
    typeof e == "string" && (e = this.languageUtils.toResolveHierarchy(e)), typeof t == "string" && (t = [t]);
    const i = this.queueLoad(e, t, r, s);
    if (!i.toLoad.length)
      return i.pending.length || s(), null;
    i.toLoad.forEach((o) => {
      this.loadOne(o);
    });
  }
  load(e, t, r) {
    this.prepareLoading(e, t, {}, r);
  }
  reload(e, t, r) {
    this.prepareLoading(e, t, {
      reload: !0
    }, r);
  }
  loadOne(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    const r = e.split("|"), s = r[0], i = r[1];
    this.read(s, i, "read", void 0, void 0, (o, u) => {
      o && this.logger.warn(`${t}loading namespace ${i} for language ${s} failed`, o), !o && u && this.logger.log(`${t}loaded namespace ${i} for language ${s}`, u), this.loaded(e, o, u);
    });
  }
  saveMissing(e, t, r, s, i) {
    let o = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {}, u = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : () => {
    };
    if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(t)) {
      this.logger.warn(`did not save key "${r}" as the namespace "${t}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
      return;
    }
    if (!(r == null || r === "")) {
      if (this.backend && this.backend.create) {
        const a = {
          ...o,
          isUpdate: i
        }, l = this.backend.create.bind(this.backend);
        if (l.length < 6)
          try {
            let f;
            l.length === 5 ? f = l(e, t, r, s, a) : f = l(e, t, r, s), f && typeof f.then == "function" ? f.then((p) => u(null, p)).catch(u) : u(null, f);
          } catch (f) {
            u(f);
          }
        else
          l(e, t, r, s, u, a);
      }
      !e || !e[0] || this.store.addResource(e[0], t, r, s);
    }
  }
}
const mn = () => ({
  debug: !1,
  initImmediate: !0,
  ns: ["translation"],
  defaultNS: ["translation"],
  fallbackLng: ["dev"],
  fallbackNS: !1,
  supportedLngs: !1,
  nonExplicitSupportedLngs: !1,
  load: "all",
  preload: !1,
  simplifyPluralSuffix: !0,
  keySeparator: ".",
  nsSeparator: ":",
  pluralSeparator: "_",
  contextSeparator: "_",
  partialBundledLanguages: !1,
  saveMissing: !1,
  updateMissing: !1,
  saveMissingTo: "fallback",
  saveMissingPlurals: !0,
  missingKeyHandler: !1,
  missingInterpolationHandler: !1,
  postProcess: !1,
  postProcessPassResolved: !1,
  returnNull: !1,
  returnEmptyString: !0,
  returnObjects: !1,
  joinArrays: !1,
  returnedObjectHandler: !1,
  parseMissingKeyHandler: !1,
  appendNamespaceToMissingKey: !1,
  appendNamespaceToCIMode: !1,
  overloadTranslationOptionHandler: (n) => {
    let e = {};
    if (typeof n[1] == "object" && (e = n[1]), typeof n[1] == "string" && (e.defaultValue = n[1]), typeof n[2] == "string" && (e.tDescription = n[2]), typeof n[2] == "object" || typeof n[3] == "object") {
      const t = n[3] || n[2];
      Object.keys(t).forEach((r) => {
        e[r] = t[r];
      });
    }
    return e;
  },
  interpolation: {
    escapeValue: !0,
    format: (n) => n,
    prefix: "{{",
    suffix: "}}",
    formatSeparator: ",",
    unescapePrefix: "-",
    nestingPrefix: "$t(",
    nestingSuffix: ")",
    nestingOptionsSeparator: ",",
    maxReplaces: 1e3,
    skipOnVariables: !0
  }
}), yn = (n) => (typeof n.ns == "string" && (n.ns = [n.ns]), typeof n.fallbackLng == "string" && (n.fallbackLng = [n.fallbackLng]), typeof n.fallbackNS == "string" && (n.fallbackNS = [n.fallbackNS]), n.supportedLngs && n.supportedLngs.indexOf("cimode") < 0 && (n.supportedLngs = n.supportedLngs.concat(["cimode"])), n), Me = () => {
}, Ds = (n) => {
  Object.getOwnPropertyNames(Object.getPrototypeOf(n)).forEach((t) => {
    typeof n[t] == "function" && (n[t] = n[t].bind(n));
  });
};
class Ne extends Qe {
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 ? arguments[1] : void 0;
    if (super(), this.options = yn(e), this.services = {}, this.logger = te, this.modules = {
      external: []
    }, Ds(this), t && !this.isInitialized && !e.isClone) {
      if (!this.options.initImmediate)
        return this.init(e, t), this;
      setTimeout(() => {
        this.init(e, t);
      }, 0);
    }
  }
  init() {
    var e = this;
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = arguments.length > 1 ? arguments[1] : void 0;
    this.isInitializing = !0, typeof t == "function" && (r = t, t = {}), !t.defaultNS && t.defaultNS !== !1 && t.ns && (typeof t.ns == "string" ? t.defaultNS = t.ns : t.ns.indexOf("translation") < 0 && (t.defaultNS = t.ns[0]));
    const s = mn();
    this.options = {
      ...s,
      ...this.options,
      ...yn(t)
    }, this.options.compatibilityAPI !== "v1" && (this.options.interpolation = {
      ...s.interpolation,
      ...this.options.interpolation
    }), t.keySeparator !== void 0 && (this.options.userDefinedKeySeparator = t.keySeparator), t.nsSeparator !== void 0 && (this.options.userDefinedNsSeparator = t.nsSeparator);
    const i = (f) => f ? typeof f == "function" ? new f() : f : null;
    if (!this.options.isClone) {
      this.modules.logger ? te.init(i(this.modules.logger), this.options) : te.init(null, this.options);
      let f;
      this.modules.formatter ? f = this.modules.formatter : typeof Intl < "u" && (f = $s);
      const p = new pn(this.options);
      this.store = new fn(this.options.resources, this.options);
      const d = this.services;
      d.logger = te, d.resourceStore = this.store, d.languageUtils = p, d.pluralResolver = new Ls(p, {
        prepend: this.options.pluralSeparator,
        compatibilityJSON: this.options.compatibilityJSON,
        simplifyPluralSuffix: this.options.simplifyPluralSuffix
      }), f && (!this.options.interpolation.format || this.options.interpolation.format === s.interpolation.format) && (d.formatter = i(f), d.formatter.init(d, this.options), this.options.interpolation.format = d.formatter.format.bind(d.formatter)), d.interpolator = new Ns(this.options), d.utils = {
        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
      }, d.backendConnector = new Is(i(this.modules.backend), d.resourceStore, d, this.options), d.backendConnector.on("*", function(m) {
        for (var h = arguments.length, w = new Array(h > 1 ? h - 1 : 0), y = 1; y < h; y++)
          w[y - 1] = arguments[y];
        e.emit(m, ...w);
      }), this.modules.languageDetector && (d.languageDetector = i(this.modules.languageDetector), d.languageDetector.init && d.languageDetector.init(d, this.options.detection, this.options)), this.modules.i18nFormat && (d.i18nFormat = i(this.modules.i18nFormat), d.i18nFormat.init && d.i18nFormat.init(this)), this.translator = new Je(this.services, this.options), this.translator.on("*", function(m) {
        for (var h = arguments.length, w = new Array(h > 1 ? h - 1 : 0), y = 1; y < h; y++)
          w[y - 1] = arguments[y];
        e.emit(m, ...w);
      }), this.modules.external.forEach((m) => {
        m.init && m.init(this);
      });
    }
    if (this.format = this.options.interpolation.format, r || (r = Me), this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
      const f = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
      f.length > 0 && f[0] !== "dev" && (this.options.lng = f[0]);
    }
    !this.services.languageDetector && !this.options.lng && this.logger.warn("init: no languageDetector is used and no lng is defined"), ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"].forEach((f) => {
      this[f] = function() {
        return e.store[f](...arguments);
      };
    }), ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"].forEach((f) => {
      this[f] = function() {
        return e.store[f](...arguments), e;
      };
    });
    const a = Oe(), l = () => {
      const f = (p, d) => {
        this.isInitializing = !1, this.isInitialized && !this.initializedStoreOnce && this.logger.warn("init: i18next is already initialized. You should call init just once!"), this.isInitialized = !0, this.options.isClone || this.logger.log("initialized", this.options), this.emit("initialized", this.options), a.resolve(d), r(p, d);
      };
      if (this.languages && this.options.compatibilityAPI !== "v1" && !this.isInitialized)
        return f(null, this.t.bind(this));
      this.changeLanguage(this.options.lng, f);
    };
    return this.options.resources || !this.options.initImmediate ? l() : setTimeout(l, 0), a;
  }
  loadResources(e) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Me;
    const s = typeof e == "string" ? e : this.language;
    if (typeof e == "function" && (r = e), !this.options.resources || this.options.partialBundledLanguages) {
      if (s && s.toLowerCase() === "cimode" && (!this.options.preload || this.options.preload.length === 0))
        return r();
      const i = [], o = (u) => {
        if (!u || u === "cimode")
          return;
        this.services.languageUtils.toResolveHierarchy(u).forEach((l) => {
          l !== "cimode" && i.indexOf(l) < 0 && i.push(l);
        });
      };
      s ? o(s) : this.services.languageUtils.getFallbackCodes(this.options.fallbackLng).forEach((a) => o(a)), this.options.preload && this.options.preload.forEach((u) => o(u)), this.services.backendConnector.load(i, this.options.ns, (u) => {
        !u && !this.resolvedLanguage && this.language && this.setResolvedLanguage(this.language), r(u);
      });
    } else
      r(null);
  }
  reloadResources(e, t, r) {
    const s = Oe();
    return typeof e == "function" && (r = e, e = void 0), typeof t == "function" && (r = t, t = void 0), e || (e = this.languages), t || (t = this.options.ns), r || (r = Me), this.services.backendConnector.reload(e, t, (i) => {
      s.resolve(), r(i);
    }), s;
  }
  use(e) {
    if (!e)
      throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
    if (!e.type)
      throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
    return e.type === "backend" && (this.modules.backend = e), (e.type === "logger" || e.log && e.warn && e.error) && (this.modules.logger = e), e.type === "languageDetector" && (this.modules.languageDetector = e), e.type === "i18nFormat" && (this.modules.i18nFormat = e), e.type === "postProcessor" && Mn.addPostProcessor(e), e.type === "formatter" && (this.modules.formatter = e), e.type === "3rdParty" && this.modules.external.push(e), this;
  }
  setResolvedLanguage(e) {
    if (!(!e || !this.languages) && !(["cimode", "dev"].indexOf(e) > -1))
      for (let t = 0; t < this.languages.length; t++) {
        const r = this.languages[t];
        if (!(["cimode", "dev"].indexOf(r) > -1) && this.store.hasLanguageSomeTranslations(r)) {
          this.resolvedLanguage = r;
          break;
        }
      }
  }
  changeLanguage(e, t) {
    var r = this;
    this.isLanguageChangingTo = e;
    const s = Oe();
    this.emit("languageChanging", e);
    const i = (a) => {
      this.language = a, this.languages = this.services.languageUtils.toResolveHierarchy(a), this.resolvedLanguage = void 0, this.setResolvedLanguage(a);
    }, o = (a, l) => {
      l ? (i(l), this.translator.changeLanguage(l), this.isLanguageChangingTo = void 0, this.emit("languageChanged", l), this.logger.log("languageChanged", l)) : this.isLanguageChangingTo = void 0, s.resolve(function() {
        return r.t(...arguments);
      }), t && t(a, function() {
        return r.t(...arguments);
      });
    }, u = (a) => {
      !e && !a && this.services.languageDetector && (a = []);
      const l = typeof a == "string" ? a : this.services.languageUtils.getBestMatchFromCodes(a);
      l && (this.language || i(l), this.translator.language || this.translator.changeLanguage(l), this.services.languageDetector && this.services.languageDetector.cacheUserLanguage && this.services.languageDetector.cacheUserLanguage(l)), this.loadResources(l, (f) => {
        o(f, l);
      });
    };
    return !e && this.services.languageDetector && !this.services.languageDetector.async ? u(this.services.languageDetector.detect()) : !e && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect.length === 0 ? this.services.languageDetector.detect().then(u) : this.services.languageDetector.detect(u) : u(e), s;
  }
  getFixedT(e, t, r) {
    var s = this;
    const i = function(o, u) {
      let a;
      if (typeof u != "object") {
        for (var l = arguments.length, f = new Array(l > 2 ? l - 2 : 0), p = 2; p < l; p++)
          f[p - 2] = arguments[p];
        a = s.options.overloadTranslationOptionHandler([o, u].concat(f));
      } else
        a = {
          ...u
        };
      a.lng = a.lng || i.lng, a.lngs = a.lngs || i.lngs, a.ns = a.ns || i.ns, a.keyPrefix !== "" && (a.keyPrefix = a.keyPrefix || r || i.keyPrefix);
      const d = s.options.keySeparator || ".";
      let m;
      return a.keyPrefix && Array.isArray(o) ? m = o.map((h) => `${a.keyPrefix}${d}${h}`) : m = a.keyPrefix ? `${a.keyPrefix}${d}${o}` : o, s.t(m, a);
    };
    return typeof e == "string" ? i.lng = e : i.lngs = e, i.ns = t, i.keyPrefix = r, i;
  }
  t() {
    return this.translator && this.translator.translate(...arguments);
  }
  exists() {
    return this.translator && this.translator.exists(...arguments);
  }
  setDefaultNamespace(e) {
    this.options.defaultNS = e;
  }
  hasLoadedNamespace(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!this.isInitialized)
      return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
    if (!this.languages || !this.languages.length)
      return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
    const r = t.lng || this.resolvedLanguage || this.languages[0], s = this.options ? this.options.fallbackLng : !1, i = this.languages[this.languages.length - 1];
    if (r.toLowerCase() === "cimode")
      return !0;
    const o = (u, a) => {
      const l = this.services.backendConnector.state[`${u}|${a}`];
      return l === -1 || l === 0 || l === 2;
    };
    if (t.precheck) {
      const u = t.precheck(this, o);
      if (u !== void 0)
        return u;
    }
    return !!(this.hasResourceBundle(r, e) || !this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages || o(r, e) && (!s || o(i, e)));
  }
  loadNamespaces(e, t) {
    const r = Oe();
    return this.options.ns ? (typeof e == "string" && (e = [e]), e.forEach((s) => {
      this.options.ns.indexOf(s) < 0 && this.options.ns.push(s);
    }), this.loadResources((s) => {
      r.resolve(), t && t(s);
    }), r) : (t && t(), Promise.resolve());
  }
  loadLanguages(e, t) {
    const r = Oe();
    typeof e == "string" && (e = [e]);
    const s = this.options.preload || [], i = e.filter((o) => s.indexOf(o) < 0 && this.services.languageUtils.isSupportedCode(o));
    return i.length ? (this.options.preload = s.concat(i), this.loadResources((o) => {
      r.resolve(), t && t(o);
    }), r) : (t && t(), Promise.resolve());
  }
  dir(e) {
    if (e || (e = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language)), !e)
      return "rtl";
    const t = ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"], r = this.services && this.services.languageUtils || new pn(mn());
    return t.indexOf(r.getLanguagePartFromCode(e)) > -1 || e.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
  }
  static createInstance() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 ? arguments[1] : void 0;
    return new Ne(e, t);
  }
  cloneInstance() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Me;
    const r = e.forkResourceStore;
    r && delete e.forkResourceStore;
    const s = {
      ...this.options,
      ...e,
      isClone: !0
    }, i = new Ne(s);
    return (e.debug !== void 0 || e.prefix !== void 0) && (i.logger = i.logger.clone(e)), ["store", "services", "language"].forEach((u) => {
      i[u] = this[u];
    }), i.services = {
      ...this.services
    }, i.services.utils = {
      hasLoadedNamespace: i.hasLoadedNamespace.bind(i)
    }, r && (i.store = new fn(this.store.data, s), i.services.resourceStore = i.store), i.translator = new Je(i.services, s), i.translator.on("*", function(u) {
      for (var a = arguments.length, l = new Array(a > 1 ? a - 1 : 0), f = 1; f < a; f++)
        l[f - 1] = arguments[f];
      i.emit(u, ...l);
    }), i.init(s, t), i.translator.options = s, i.translator.backendConnector.services.utils = {
      hasLoadedNamespace: i.hasLoadedNamespace.bind(i)
    }, i;
  }
  toJSON() {
    return {
      options: this.options,
      store: this.store,
      language: this.language,
      languages: this.languages,
      resolvedLanguage: this.resolvedLanguage
    };
  }
}
const M = Ne.createInstance();
M.createInstance = Ne.createInstance;
M.createInstance;
M.dir;
M.init;
M.loadResources;
M.reloadResources;
M.use;
M.changeLanguage;
M.getFixedT;
M.t;
M.exists;
M.setDefaultNamespace;
M.hasLoadedNamespace;
M.loadNamespaces;
M.loadLanguages;
function js(n, e) {
  if (!(n instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function ke(n) {
  "@babel/helpers - typeof";
  return ke = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, ke(n);
}
function _s(n, e) {
  if (ke(n) != "object" || !n)
    return n;
  var t = n[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(n, e);
    if (ke(r) != "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(n);
}
function Us(n) {
  var e = _s(n, "string");
  return ke(e) == "symbol" ? e : e + "";
}
function Bs(n, e) {
  for (var t = 0; t < e.length; t++) {
    var r = e[t];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(n, Us(r.key), r);
  }
}
function Ms(n, e, t) {
  return e && Bs(n.prototype, e), Object.defineProperty(n, "prototype", {
    writable: !1
  }), n;
}
var Hn = [], Hs = Hn.forEach, Vs = Hn.slice;
function qs(n) {
  return Hs.call(Vs.call(arguments, 1), function(e) {
    if (e)
      for (var t in e)
        n[t] === void 0 && (n[t] = e[t]);
  }), n;
}
var bn = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/, zs = function(e, t, r) {
  var s = r || {};
  s.path = s.path || "/";
  var i = encodeURIComponent(t), o = "".concat(e, "=").concat(i);
  if (s.maxAge > 0) {
    var u = s.maxAge - 0;
    if (Number.isNaN(u))
      throw new Error("maxAge should be a Number");
    o += "; Max-Age=".concat(Math.floor(u));
  }
  if (s.domain) {
    if (!bn.test(s.domain))
      throw new TypeError("option domain is invalid");
    o += "; Domain=".concat(s.domain);
  }
  if (s.path) {
    if (!bn.test(s.path))
      throw new TypeError("option path is invalid");
    o += "; Path=".concat(s.path);
  }
  if (s.expires) {
    if (typeof s.expires.toUTCString != "function")
      throw new TypeError("option expires is invalid");
    o += "; Expires=".concat(s.expires.toUTCString());
  }
  if (s.httpOnly && (o += "; HttpOnly"), s.secure && (o += "; Secure"), s.sameSite) {
    var a = typeof s.sameSite == "string" ? s.sameSite.toLowerCase() : s.sameSite;
    switch (a) {
      case !0:
        o += "; SameSite=Strict";
        break;
      case "lax":
        o += "; SameSite=Lax";
        break;
      case "strict":
        o += "; SameSite=Strict";
        break;
      case "none":
        o += "; SameSite=None";
        break;
      default:
        throw new TypeError("option sameSite is invalid");
    }
  }
  return o;
}, wn = {
  create: function(e, t, r, s) {
    var i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
      path: "/",
      sameSite: "strict"
    };
    r && (i.expires = /* @__PURE__ */ new Date(), i.expires.setTime(i.expires.getTime() + r * 60 * 1e3)), s && (i.domain = s), document.cookie = zs(e, encodeURIComponent(t), i);
  },
  read: function(e) {
    for (var t = "".concat(e, "="), r = document.cookie.split(";"), s = 0; s < r.length; s++) {
      for (var i = r[s]; i.charAt(0) === " "; )
        i = i.substring(1, i.length);
      if (i.indexOf(t) === 0)
        return i.substring(t.length, i.length);
    }
    return null;
  },
  remove: function(e) {
    this.create(e, "", -1);
  }
}, Ks = {
  name: "cookie",
  lookup: function(e) {
    var t;
    if (e.lookupCookie && typeof document < "u") {
      var r = wn.read(e.lookupCookie);
      r && (t = r);
    }
    return t;
  },
  cacheUserLanguage: function(e, t) {
    t.lookupCookie && typeof document < "u" && wn.create(t.lookupCookie, e, t.cookieMinutes, t.cookieDomain, t.cookieOptions);
  }
}, Js = {
  name: "querystring",
  lookup: function(e) {
    var t;
    if (typeof window < "u") {
      var r = window.location.search;
      !window.location.search && window.location.hash && window.location.hash.indexOf("?") > -1 && (r = window.location.hash.substring(window.location.hash.indexOf("?")));
      for (var s = r.substring(1), i = s.split("&"), o = 0; o < i.length; o++) {
        var u = i[o].indexOf("=");
        if (u > 0) {
          var a = i[o].substring(0, u);
          a === e.lookupQuerystring && (t = i[o].substring(u + 1));
        }
      }
    }
    return t;
  }
}, Ae = null, vn = function() {
  if (Ae !== null)
    return Ae;
  try {
    Ae = window !== "undefined" && window.localStorage !== null;
    var e = "i18next.translate.boo";
    window.localStorage.setItem(e, "foo"), window.localStorage.removeItem(e);
  } catch {
    Ae = !1;
  }
  return Ae;
}, Gs = {
  name: "localStorage",
  lookup: function(e) {
    var t;
    if (e.lookupLocalStorage && vn()) {
      var r = window.localStorage.getItem(e.lookupLocalStorage);
      r && (t = r);
    }
    return t;
  },
  cacheUserLanguage: function(e, t) {
    t.lookupLocalStorage && vn() && window.localStorage.setItem(t.lookupLocalStorage, e);
  }
}, Te = null, Sn = function() {
  if (Te !== null)
    return Te;
  try {
    Te = window !== "undefined" && window.sessionStorage !== null;
    var e = "i18next.translate.boo";
    window.sessionStorage.setItem(e, "foo"), window.sessionStorage.removeItem(e);
  } catch {
    Te = !1;
  }
  return Te;
}, Ws = {
  name: "sessionStorage",
  lookup: function(e) {
    var t;
    if (e.lookupSessionStorage && Sn()) {
      var r = window.sessionStorage.getItem(e.lookupSessionStorage);
      r && (t = r);
    }
    return t;
  },
  cacheUserLanguage: function(e, t) {
    t.lookupSessionStorage && Sn() && window.sessionStorage.setItem(t.lookupSessionStorage, e);
  }
}, Ys = {
  name: "navigator",
  lookup: function(e) {
    var t = [];
    if (typeof navigator < "u") {
      if (navigator.languages)
        for (var r = 0; r < navigator.languages.length; r++)
          t.push(navigator.languages[r]);
      navigator.userLanguage && t.push(navigator.userLanguage), navigator.language && t.push(navigator.language);
    }
    return t.length > 0 ? t : void 0;
  }
}, Qs = {
  name: "htmlTag",
  lookup: function(e) {
    var t, r = e.htmlTag || (typeof document < "u" ? document.documentElement : null);
    return r && typeof r.getAttribute == "function" && (t = r.getAttribute("lang")), t;
  }
}, Xs = {
  name: "path",
  lookup: function(e) {
    var t;
    if (typeof window < "u") {
      var r = window.location.pathname.match(/\/([a-zA-Z-]*)/g);
      if (r instanceof Array)
        if (typeof e.lookupFromPathIndex == "number") {
          if (typeof r[e.lookupFromPathIndex] != "string")
            return;
          t = r[e.lookupFromPathIndex].replace("/", "");
        } else
          t = r[0].replace("/", "");
    }
    return t;
  }
}, Zs = {
  name: "subdomain",
  lookup: function(e) {
    var t = typeof e.lookupFromSubdomainIndex == "number" ? e.lookupFromSubdomainIndex + 1 : 1, r = typeof window < "u" && window.location && window.location.hostname && window.location.hostname.match(/^(\w{2,5})\.(([a-z0-9-]{1,63}\.[a-z]{2,6})|localhost)/i);
    if (r)
      return r[t];
  }
};
function ei() {
  return {
    order: ["querystring", "cookie", "localStorage", "sessionStorage", "navigator", "htmlTag"],
    lookupQuerystring: "lng",
    lookupCookie: "i18next",
    lookupLocalStorage: "i18nextLng",
    lookupSessionStorage: "i18nextLng",
    // cache user language
    caches: ["localStorage"],
    excludeCacheFor: ["cimode"],
    // cookieMinutes: 10,
    // cookieDomain: 'myDomain'
    convertDetectedLanguage: function(e) {
      return e;
    }
  };
}
var Vn = /* @__PURE__ */ function() {
  function n(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    js(this, n), this.type = "languageDetector", this.detectors = {}, this.init(e, t);
  }
  return Ms(n, [{
    key: "init",
    value: function(t) {
      var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      this.services = t || {
        languageUtils: {}
      }, this.options = qs(r, this.options || {}, ei()), typeof this.options.convertDetectedLanguage == "string" && this.options.convertDetectedLanguage.indexOf("15897") > -1 && (this.options.convertDetectedLanguage = function(i) {
        return i.replace("-", "_");
      }), this.options.lookupFromUrlIndex && (this.options.lookupFromPathIndex = this.options.lookupFromUrlIndex), this.i18nOptions = s, this.addDetector(Ks), this.addDetector(Js), this.addDetector(Gs), this.addDetector(Ws), this.addDetector(Ys), this.addDetector(Qs), this.addDetector(Xs), this.addDetector(Zs);
    }
  }, {
    key: "addDetector",
    value: function(t) {
      return this.detectors[t.name] = t, this;
    }
  }, {
    key: "detect",
    value: function(t) {
      var r = this;
      t || (t = this.options.order);
      var s = [];
      return t.forEach(function(i) {
        if (r.detectors[i]) {
          var o = r.detectors[i].lookup(r.options);
          o && typeof o == "string" && (o = [o]), o && (s = s.concat(o));
        }
      }), s = s.map(function(i) {
        return r.options.convertDetectedLanguage(i);
      }), this.services.languageUtils.getBestMatchFromCodes ? s : s.length > 0 ? s[0] : null;
    }
  }, {
    key: "cacheUserLanguage",
    value: function(t, r) {
      var s = this;
      r || (r = this.options.caches), r && (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(t) > -1 || r.forEach(function(i) {
        s.detectors[i] && s.detectors[i].cacheUserLanguage(t, s.options);
      }));
    }
  }]), n;
}();
Vn.type = "languageDetector";
const ge = M.createInstance();
ge.use(us).use(Vn).init({
  debug: !1,
  fallbackLng: "en",
  defaultNS: "translation",
  interpolation: { escapeValue: !1 },
  detection: {
    lookupCookie: ps
  }
});
function Jo(n, e) {
  if (n && !ge.hasResourceBundle("en", n))
    for (const t in e) {
      const r = e[t].default, s = t.replace(/\.[^/.]+$/, "").split("/").slice(-1)[0];
      ge.addResourceBundle(
        s,
        n,
        Object.entries(r).reduce((i, [o, u]) => ({ [o]: u, ...i }), {}),
        !0
      );
    }
}
function ti({ children: n, ns: e }) {
  return /* @__PURE__ */ Yr.jsx(ds, { i18n: ge, defaultNS: e ?? "common", children: n });
}
const ni = fs, Go = ge;
function qn(n, e) {
  return function() {
    return n.apply(e, arguments);
  };
}
const { toString: ri } = Object.prototype, { getPrototypeOf: kt } = Object, Xe = /* @__PURE__ */ ((n) => (e) => {
  const t = ri.call(e);
  return n[t] || (n[t] = t.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), Z = (n) => (n = n.toLowerCase(), (e) => Xe(e) === n), Ze = (n) => (e) => typeof e === n, { isArray: me } = Array, $e = Ze("undefined");
function si(n) {
  return n !== null && !$e(n) && n.constructor !== null && !$e(n.constructor) && J(n.constructor.isBuffer) && n.constructor.isBuffer(n);
}
const zn = Z("ArrayBuffer");
function ii(n) {
  let e;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? e = ArrayBuffer.isView(n) : e = n && n.buffer && zn(n.buffer), e;
}
const oi = Ze("string"), J = Ze("function"), Kn = Ze("number"), et = (n) => n !== null && typeof n == "object", ai = (n) => n === !0 || n === !1, He = (n) => {
  if (Xe(n) !== "object")
    return !1;
  const e = kt(n);
  return (e === null || e === Object.prototype || Object.getPrototypeOf(e) === null) && !(Symbol.toStringTag in n) && !(Symbol.iterator in n);
}, ui = Z("Date"), li = Z("File"), ci = Z("Blob"), fi = Z("FileList"), di = (n) => et(n) && J(n.pipe), pi = (n) => {
  let e;
  return n && (typeof FormData == "function" && n instanceof FormData || J(n.append) && ((e = Xe(n)) === "formdata" || // detect form-data instance
  e === "object" && J(n.toString) && n.toString() === "[object FormData]"));
}, hi = Z("URLSearchParams"), [gi, mi, yi, bi] = ["ReadableStream", "Request", "Response", "Headers"].map(Z), wi = (n) => n.trim ? n.trim() : n.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function Fe(n, e, { allOwnKeys: t = !1 } = {}) {
  if (n === null || typeof n > "u")
    return;
  let r, s;
  if (typeof n != "object" && (n = [n]), me(n))
    for (r = 0, s = n.length; r < s; r++)
      e.call(null, n[r], r, n);
  else {
    const i = t ? Object.getOwnPropertyNames(n) : Object.keys(n), o = i.length;
    let u;
    for (r = 0; r < o; r++)
      u = i[r], e.call(null, n[u], u, n);
  }
}
function Jn(n, e) {
  e = e.toLowerCase();
  const t = Object.keys(n);
  let r = t.length, s;
  for (; r-- > 0; )
    if (s = t[r], e === s.toLowerCase())
      return s;
  return null;
}
const ue = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, Gn = (n) => !$e(n) && n !== ue;
function Ot() {
  const { caseless: n } = Gn(this) && this || {}, e = {}, t = (r, s) => {
    const i = n && Jn(e, s) || s;
    He(e[i]) && He(r) ? e[i] = Ot(e[i], r) : He(r) ? e[i] = Ot({}, r) : me(r) ? e[i] = r.slice() : e[i] = r;
  };
  for (let r = 0, s = arguments.length; r < s; r++)
    arguments[r] && Fe(arguments[r], t);
  return e;
}
const vi = (n, e, t, { allOwnKeys: r } = {}) => (Fe(e, (s, i) => {
  t && J(s) ? n[i] = qn(s, t) : n[i] = s;
}, { allOwnKeys: r }), n), Si = (n) => (n.charCodeAt(0) === 65279 && (n = n.slice(1)), n), xi = (n, e, t, r) => {
  n.prototype = Object.create(e.prototype, r), n.prototype.constructor = n, Object.defineProperty(n, "super", {
    value: e.prototype
  }), t && Object.assign(n.prototype, t);
}, Ei = (n, e, t, r) => {
  let s, i, o;
  const u = {};
  if (e = e || {}, n == null)
    return e;
  do {
    for (s = Object.getOwnPropertyNames(n), i = s.length; i-- > 0; )
      o = s[i], (!r || r(o, n, e)) && !u[o] && (e[o] = n[o], u[o] = !0);
    n = t !== !1 && kt(n);
  } while (n && (!t || t(n, e)) && n !== Object.prototype);
  return e;
}, Ri = (n, e, t) => {
  n = String(n), (t === void 0 || t > n.length) && (t = n.length), t -= e.length;
  const r = n.indexOf(e, t);
  return r !== -1 && r === t;
}, Oi = (n) => {
  if (!n)
    return null;
  if (me(n))
    return n;
  let e = n.length;
  if (!Kn(e))
    return null;
  const t = new Array(e);
  for (; e-- > 0; )
    t[e] = n[e];
  return t;
}, Ai = /* @__PURE__ */ ((n) => (e) => n && e instanceof n)(typeof Uint8Array < "u" && kt(Uint8Array)), Ti = (n, e) => {
  const r = (n && n[Symbol.iterator]).call(n);
  let s;
  for (; (s = r.next()) && !s.done; ) {
    const i = s.value;
    e.call(n, i[0], i[1]);
  }
}, Ci = (n, e) => {
  let t;
  const r = [];
  for (; (t = n.exec(e)) !== null; )
    r.push(t);
  return r;
}, Pi = Z("HTMLFormElement"), Li = (n) => n.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(t, r, s) {
    return r.toUpperCase() + s;
  }
), xn = (({ hasOwnProperty: n }) => (e, t) => n.call(e, t))(Object.prototype), Ni = Z("RegExp"), Wn = (n, e) => {
  const t = Object.getOwnPropertyDescriptors(n), r = {};
  Fe(t, (s, i) => {
    let o;
    (o = e(s, i, n)) !== !1 && (r[i] = o || s);
  }), Object.defineProperties(n, r);
}, ki = (n) => {
  Wn(n, (e, t) => {
    if (J(n) && ["arguments", "caller", "callee"].indexOf(t) !== -1)
      return !1;
    const r = n[t];
    if (J(r)) {
      if (e.enumerable = !1, "writable" in e) {
        e.writable = !1;
        return;
      }
      e.set || (e.set = () => {
        throw Error("Can not rewrite read-only method '" + t + "'");
      });
    }
  });
}, $i = (n, e) => {
  const t = {}, r = (s) => {
    s.forEach((i) => {
      t[i] = !0;
    });
  };
  return me(n) ? r(n) : r(String(n).split(e)), t;
}, Fi = () => {
}, Ii = (n, e) => n != null && Number.isFinite(n = +n) ? n : e, gt = "abcdefghijklmnopqrstuvwxyz", En = "0123456789", Yn = {
  DIGIT: En,
  ALPHA: gt,
  ALPHA_DIGIT: gt + gt.toUpperCase() + En
}, Di = (n = 16, e = Yn.ALPHA_DIGIT) => {
  let t = "";
  const { length: r } = e;
  for (; n--; )
    t += e[Math.random() * r | 0];
  return t;
};
function ji(n) {
  return !!(n && J(n.append) && n[Symbol.toStringTag] === "FormData" && n[Symbol.iterator]);
}
const _i = (n) => {
  const e = new Array(10), t = (r, s) => {
    if (et(r)) {
      if (e.indexOf(r) >= 0)
        return;
      if (!("toJSON" in r)) {
        e[s] = r;
        const i = me(r) ? [] : {};
        return Fe(r, (o, u) => {
          const a = t(o, s + 1);
          !$e(a) && (i[u] = a);
        }), e[s] = void 0, i;
      }
    }
    return r;
  };
  return t(n, 0);
}, Ui = Z("AsyncFunction"), Bi = (n) => n && (et(n) || J(n)) && J(n.then) && J(n.catch), Qn = ((n, e) => n ? setImmediate : e ? ((t, r) => (ue.addEventListener("message", ({ source: s, data: i }) => {
  s === ue && i === t && r.length && r.shift()();
}, !1), (s) => {
  r.push(s), ue.postMessage(t, "*");
}))(`axios@${Math.random()}`, []) : (t) => setTimeout(t))(
  typeof setImmediate == "function",
  J(ue.postMessage)
), Mi = typeof queueMicrotask < "u" ? queueMicrotask.bind(ue) : typeof process < "u" && process.nextTick || Qn, g = {
  isArray: me,
  isArrayBuffer: zn,
  isBuffer: si,
  isFormData: pi,
  isArrayBufferView: ii,
  isString: oi,
  isNumber: Kn,
  isBoolean: ai,
  isObject: et,
  isPlainObject: He,
  isReadableStream: gi,
  isRequest: mi,
  isResponse: yi,
  isHeaders: bi,
  isUndefined: $e,
  isDate: ui,
  isFile: li,
  isBlob: ci,
  isRegExp: Ni,
  isFunction: J,
  isStream: di,
  isURLSearchParams: hi,
  isTypedArray: Ai,
  isFileList: fi,
  forEach: Fe,
  merge: Ot,
  extend: vi,
  trim: wi,
  stripBOM: Si,
  inherits: xi,
  toFlatObject: Ei,
  kindOf: Xe,
  kindOfTest: Z,
  endsWith: Ri,
  toArray: Oi,
  forEachEntry: Ti,
  matchAll: Ci,
  isHTMLForm: Pi,
  hasOwnProperty: xn,
  hasOwnProp: xn,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: Wn,
  freezeMethods: ki,
  toObjectSet: $i,
  toCamelCase: Li,
  noop: Fi,
  toFiniteNumber: Ii,
  findKey: Jn,
  global: ue,
  isContextDefined: Gn,
  ALPHABET: Yn,
  generateString: Di,
  isSpecCompliantForm: ji,
  toJSONObject: _i,
  isAsyncFn: Ui,
  isThenable: Bi,
  setImmediate: Qn,
  asap: Mi
};
function T(n, e, t, r, s) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = n, this.name = "AxiosError", e && (this.code = e), t && (this.config = t), r && (this.request = r), s && (this.response = s, this.status = s.status ? s.status : null);
}
g.inherits(T, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: g.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const Xn = T.prototype, Zn = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((n) => {
  Zn[n] = { value: n };
});
Object.defineProperties(T, Zn);
Object.defineProperty(Xn, "isAxiosError", { value: !0 });
T.from = (n, e, t, r, s, i) => {
  const o = Object.create(Xn);
  return g.toFlatObject(n, o, function(a) {
    return a !== Error.prototype;
  }, (u) => u !== "isAxiosError"), T.call(o, n.message, e, t, r, s), o.cause = n, o.name = n.name, i && Object.assign(o, i), o;
};
const Hi = null;
function At(n) {
  return g.isPlainObject(n) || g.isArray(n);
}
function er(n) {
  return g.endsWith(n, "[]") ? n.slice(0, -2) : n;
}
function Rn(n, e, t) {
  return n ? n.concat(e).map(function(s, i) {
    return s = er(s), !t && i ? "[" + s + "]" : s;
  }).join(t ? "." : "") : e;
}
function Vi(n) {
  return g.isArray(n) && !n.some(At);
}
const qi = g.toFlatObject(g, {}, null, function(e) {
  return /^is[A-Z]/.test(e);
});
function tt(n, e, t) {
  if (!g.isObject(n))
    throw new TypeError("target must be an object");
  e = e || new FormData(), t = g.toFlatObject(t, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(w, y) {
    return !g.isUndefined(y[w]);
  });
  const r = t.metaTokens, s = t.visitor || f, i = t.dots, o = t.indexes, a = (t.Blob || typeof Blob < "u" && Blob) && g.isSpecCompliantForm(e);
  if (!g.isFunction(s))
    throw new TypeError("visitor must be a function");
  function l(h) {
    if (h === null)
      return "";
    if (g.isDate(h))
      return h.toISOString();
    if (!a && g.isBlob(h))
      throw new T("Blob is not supported. Use a Buffer instead.");
    return g.isArrayBuffer(h) || g.isTypedArray(h) ? a && typeof Blob == "function" ? new Blob([h]) : Buffer.from(h) : h;
  }
  function f(h, w, y) {
    let v = h;
    if (h && !y && typeof h == "object") {
      if (g.endsWith(w, "{}"))
        w = r ? w : w.slice(0, -2), h = JSON.stringify(h);
      else if (g.isArray(h) && Vi(h) || (g.isFileList(h) || g.endsWith(w, "[]")) && (v = g.toArray(h)))
        return w = er(w), v.forEach(function(E, R) {
          !(g.isUndefined(E) || E === null) && e.append(
            // eslint-disable-next-line no-nested-ternary
            o === !0 ? Rn([w], R, i) : o === null ? w : w + "[]",
            l(E)
          );
        }), !1;
    }
    return At(h) ? !0 : (e.append(Rn(y, w, i), l(h)), !1);
  }
  const p = [], d = Object.assign(qi, {
    defaultVisitor: f,
    convertValue: l,
    isVisitable: At
  });
  function m(h, w) {
    if (!g.isUndefined(h)) {
      if (p.indexOf(h) !== -1)
        throw Error("Circular reference detected in " + w.join("."));
      p.push(h), g.forEach(h, function(v, x) {
        (!(g.isUndefined(v) || v === null) && s.call(
          e,
          v,
          g.isString(x) ? x.trim() : x,
          w,
          d
        )) === !0 && m(v, w ? w.concat(x) : [x]);
      }), p.pop();
    }
  }
  if (!g.isObject(n))
    throw new TypeError("data must be an object");
  return m(n), e;
}
function On(n) {
  const e = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(n).replace(/[!'()~]|%20|%00/g, function(r) {
    return e[r];
  });
}
function $t(n, e) {
  this._pairs = [], n && tt(n, this, e);
}
const tr = $t.prototype;
tr.append = function(e, t) {
  this._pairs.push([e, t]);
};
tr.toString = function(e) {
  const t = e ? function(r) {
    return e.call(this, r, On);
  } : On;
  return this._pairs.map(function(s) {
    return t(s[0]) + "=" + t(s[1]);
  }, "").join("&");
};
function zi(n) {
  return encodeURIComponent(n).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function nr(n, e, t) {
  if (!e)
    return n;
  const r = t && t.encode || zi, s = t && t.serialize;
  let i;
  if (s ? i = s(e, t) : i = g.isURLSearchParams(e) ? e.toString() : new $t(e, t).toString(r), i) {
    const o = n.indexOf("#");
    o !== -1 && (n = n.slice(0, o)), n += (n.indexOf("?") === -1 ? "?" : "&") + i;
  }
  return n;
}
class An {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(e, t, r) {
    return this.handlers.push({
      fulfilled: e,
      rejected: t,
      synchronous: r ? r.synchronous : !1,
      runWhen: r ? r.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(e) {
    this.handlers[e] && (this.handlers[e] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(e) {
    g.forEach(this.handlers, function(r) {
      r !== null && e(r);
    });
  }
}
const rr = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, Ki = typeof URLSearchParams < "u" ? URLSearchParams : $t, Ji = typeof FormData < "u" ? FormData : null, Gi = typeof Blob < "u" ? Blob : null, Wi = {
  isBrowser: !0,
  classes: {
    URLSearchParams: Ki,
    FormData: Ji,
    Blob: Gi
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, Ft = typeof window < "u" && typeof document < "u", Tt = typeof navigator == "object" && navigator || void 0, Yi = Ft && (!Tt || ["ReactNative", "NativeScript", "NS"].indexOf(Tt.product) < 0), Qi = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", Xi = Ft && window.location.href || "http://localhost", Zi = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: Ft,
  hasStandardBrowserEnv: Yi,
  hasStandardBrowserWebWorkerEnv: Qi,
  navigator: Tt,
  origin: Xi
}, Symbol.toStringTag, { value: "Module" })), q = {
  ...Zi,
  ...Wi
};
function eo(n, e) {
  return tt(n, new q.classes.URLSearchParams(), Object.assign({
    visitor: function(t, r, s, i) {
      return q.isNode && g.isBuffer(t) ? (this.append(r, t.toString("base64")), !1) : i.defaultVisitor.apply(this, arguments);
    }
  }, e));
}
function to(n) {
  return g.matchAll(/\w+|\[(\w*)]/g, n).map((e) => e[0] === "[]" ? "" : e[1] || e[0]);
}
function no(n) {
  const e = {}, t = Object.keys(n);
  let r;
  const s = t.length;
  let i;
  for (r = 0; r < s; r++)
    i = t[r], e[i] = n[i];
  return e;
}
function sr(n) {
  function e(t, r, s, i) {
    let o = t[i++];
    if (o === "__proto__")
      return !0;
    const u = Number.isFinite(+o), a = i >= t.length;
    return o = !o && g.isArray(s) ? s.length : o, a ? (g.hasOwnProp(s, o) ? s[o] = [s[o], r] : s[o] = r, !u) : ((!s[o] || !g.isObject(s[o])) && (s[o] = []), e(t, r, s[o], i) && g.isArray(s[o]) && (s[o] = no(s[o])), !u);
  }
  if (g.isFormData(n) && g.isFunction(n.entries)) {
    const t = {};
    return g.forEachEntry(n, (r, s) => {
      e(to(r), s, t, 0);
    }), t;
  }
  return null;
}
function ro(n, e, t) {
  if (g.isString(n))
    try {
      return (e || JSON.parse)(n), g.trim(n);
    } catch (r) {
      if (r.name !== "SyntaxError")
        throw r;
    }
  return (t || JSON.stringify)(n);
}
const Ie = {
  transitional: rr,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(e, t) {
    const r = t.getContentType() || "", s = r.indexOf("application/json") > -1, i = g.isObject(e);
    if (i && g.isHTMLForm(e) && (e = new FormData(e)), g.isFormData(e))
      return s ? JSON.stringify(sr(e)) : e;
    if (g.isArrayBuffer(e) || g.isBuffer(e) || g.isStream(e) || g.isFile(e) || g.isBlob(e) || g.isReadableStream(e))
      return e;
    if (g.isArrayBufferView(e))
      return e.buffer;
    if (g.isURLSearchParams(e))
      return t.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), e.toString();
    let u;
    if (i) {
      if (r.indexOf("application/x-www-form-urlencoded") > -1)
        return eo(e, this.formSerializer).toString();
      if ((u = g.isFileList(e)) || r.indexOf("multipart/form-data") > -1) {
        const a = this.env && this.env.FormData;
        return tt(
          u ? { "files[]": e } : e,
          a && new a(),
          this.formSerializer
        );
      }
    }
    return i || s ? (t.setContentType("application/json", !1), ro(e)) : e;
  }],
  transformResponse: [function(e) {
    const t = this.transitional || Ie.transitional, r = t && t.forcedJSONParsing, s = this.responseType === "json";
    if (g.isResponse(e) || g.isReadableStream(e))
      return e;
    if (e && g.isString(e) && (r && !this.responseType || s)) {
      const o = !(t && t.silentJSONParsing) && s;
      try {
        return JSON.parse(e);
      } catch (u) {
        if (o)
          throw u.name === "SyntaxError" ? T.from(u, T.ERR_BAD_RESPONSE, this, null, this.response) : u;
      }
    }
    return e;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: q.classes.FormData,
    Blob: q.classes.Blob
  },
  validateStatus: function(e) {
    return e >= 200 && e < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
g.forEach(["delete", "get", "head", "post", "put", "patch"], (n) => {
  Ie.headers[n] = {};
});
const so = g.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), io = (n) => {
  const e = {};
  let t, r, s;
  return n && n.split(`
`).forEach(function(o) {
    s = o.indexOf(":"), t = o.substring(0, s).trim().toLowerCase(), r = o.substring(s + 1).trim(), !(!t || e[t] && so[t]) && (t === "set-cookie" ? e[t] ? e[t].push(r) : e[t] = [r] : e[t] = e[t] ? e[t] + ", " + r : r);
  }), e;
}, Tn = Symbol("internals");
function Ce(n) {
  return n && String(n).trim().toLowerCase();
}
function Ve(n) {
  return n === !1 || n == null ? n : g.isArray(n) ? n.map(Ve) : String(n);
}
function oo(n) {
  const e = /* @__PURE__ */ Object.create(null), t = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let r;
  for (; r = t.exec(n); )
    e[r[1]] = r[2];
  return e;
}
const ao = (n) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(n.trim());
function mt(n, e, t, r, s) {
  if (g.isFunction(r))
    return r.call(this, e, t);
  if (s && (e = t), !!g.isString(e)) {
    if (g.isString(r))
      return e.indexOf(r) !== -1;
    if (g.isRegExp(r))
      return r.test(e);
  }
}
function uo(n) {
  return n.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (e, t, r) => t.toUpperCase() + r);
}
function lo(n, e) {
  const t = g.toCamelCase(" " + e);
  ["get", "set", "has"].forEach((r) => {
    Object.defineProperty(n, r + t, {
      value: function(s, i, o) {
        return this[r].call(this, e, s, i, o);
      },
      configurable: !0
    });
  });
}
class z {
  constructor(e) {
    e && this.set(e);
  }
  set(e, t, r) {
    const s = this;
    function i(u, a, l) {
      const f = Ce(a);
      if (!f)
        throw new Error("header name must be a non-empty string");
      const p = g.findKey(s, f);
      (!p || s[p] === void 0 || l === !0 || l === void 0 && s[p] !== !1) && (s[p || a] = Ve(u));
    }
    const o = (u, a) => g.forEach(u, (l, f) => i(l, f, a));
    if (g.isPlainObject(e) || e instanceof this.constructor)
      o(e, t);
    else if (g.isString(e) && (e = e.trim()) && !ao(e))
      o(io(e), t);
    else if (g.isHeaders(e))
      for (const [u, a] of e.entries())
        i(a, u, r);
    else
      e != null && i(t, e, r);
    return this;
  }
  get(e, t) {
    if (e = Ce(e), e) {
      const r = g.findKey(this, e);
      if (r) {
        const s = this[r];
        if (!t)
          return s;
        if (t === !0)
          return oo(s);
        if (g.isFunction(t))
          return t.call(this, s, r);
        if (g.isRegExp(t))
          return t.exec(s);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(e, t) {
    if (e = Ce(e), e) {
      const r = g.findKey(this, e);
      return !!(r && this[r] !== void 0 && (!t || mt(this, this[r], r, t)));
    }
    return !1;
  }
  delete(e, t) {
    const r = this;
    let s = !1;
    function i(o) {
      if (o = Ce(o), o) {
        const u = g.findKey(r, o);
        u && (!t || mt(r, r[u], u, t)) && (delete r[u], s = !0);
      }
    }
    return g.isArray(e) ? e.forEach(i) : i(e), s;
  }
  clear(e) {
    const t = Object.keys(this);
    let r = t.length, s = !1;
    for (; r--; ) {
      const i = t[r];
      (!e || mt(this, this[i], i, e, !0)) && (delete this[i], s = !0);
    }
    return s;
  }
  normalize(e) {
    const t = this, r = {};
    return g.forEach(this, (s, i) => {
      const o = g.findKey(r, i);
      if (o) {
        t[o] = Ve(s), delete t[i];
        return;
      }
      const u = e ? uo(i) : String(i).trim();
      u !== i && delete t[i], t[u] = Ve(s), r[u] = !0;
    }), this;
  }
  concat(...e) {
    return this.constructor.concat(this, ...e);
  }
  toJSON(e) {
    const t = /* @__PURE__ */ Object.create(null);
    return g.forEach(this, (r, s) => {
      r != null && r !== !1 && (t[s] = e && g.isArray(r) ? r.join(", ") : r);
    }), t;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([e, t]) => e + ": " + t).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(e) {
    return e instanceof this ? e : new this(e);
  }
  static concat(e, ...t) {
    const r = new this(e);
    return t.forEach((s) => r.set(s)), r;
  }
  static accessor(e) {
    const r = (this[Tn] = this[Tn] = {
      accessors: {}
    }).accessors, s = this.prototype;
    function i(o) {
      const u = Ce(o);
      r[u] || (lo(s, o), r[u] = !0);
    }
    return g.isArray(e) ? e.forEach(i) : i(e), this;
  }
}
z.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
g.reduceDescriptors(z.prototype, ({ value: n }, e) => {
  let t = e[0].toUpperCase() + e.slice(1);
  return {
    get: () => n,
    set(r) {
      this[t] = r;
    }
  };
});
g.freezeMethods(z);
function yt(n, e) {
  const t = this || Ie, r = e || t, s = z.from(r.headers);
  let i = r.data;
  return g.forEach(n, function(u) {
    i = u.call(t, i, s.normalize(), e ? e.status : void 0);
  }), s.normalize(), i;
}
function ir(n) {
  return !!(n && n.__CANCEL__);
}
function ye(n, e, t) {
  T.call(this, n ?? "canceled", T.ERR_CANCELED, e, t), this.name = "CanceledError";
}
g.inherits(ye, T, {
  __CANCEL__: !0
});
function or(n, e, t) {
  const r = t.config.validateStatus;
  !t.status || !r || r(t.status) ? n(t) : e(new T(
    "Request failed with status code " + t.status,
    [T.ERR_BAD_REQUEST, T.ERR_BAD_RESPONSE][Math.floor(t.status / 100) - 4],
    t.config,
    t.request,
    t
  ));
}
function co(n) {
  const e = /^([-+\w]{1,25})(:?\/\/|:)/.exec(n);
  return e && e[1] || "";
}
function fo(n, e) {
  n = n || 10;
  const t = new Array(n), r = new Array(n);
  let s = 0, i = 0, o;
  return e = e !== void 0 ? e : 1e3, function(a) {
    const l = Date.now(), f = r[i];
    o || (o = l), t[s] = a, r[s] = l;
    let p = i, d = 0;
    for (; p !== s; )
      d += t[p++], p = p % n;
    if (s = (s + 1) % n, s === i && (i = (i + 1) % n), l - o < e)
      return;
    const m = f && l - f;
    return m ? Math.round(d * 1e3 / m) : void 0;
  };
}
function po(n, e) {
  let t = 0, r = 1e3 / e, s, i;
  const o = (l, f = Date.now()) => {
    t = f, s = null, i && (clearTimeout(i), i = null), n.apply(null, l);
  };
  return [(...l) => {
    const f = Date.now(), p = f - t;
    p >= r ? o(l, f) : (s = l, i || (i = setTimeout(() => {
      i = null, o(s);
    }, r - p)));
  }, () => s && o(s)];
}
const Ge = (n, e, t = 3) => {
  let r = 0;
  const s = fo(50, 250);
  return po((i) => {
    const o = i.loaded, u = i.lengthComputable ? i.total : void 0, a = o - r, l = s(a), f = o <= u;
    r = o;
    const p = {
      loaded: o,
      total: u,
      progress: u ? o / u : void 0,
      bytes: a,
      rate: l || void 0,
      estimated: l && u && f ? (u - o) / l : void 0,
      event: i,
      lengthComputable: u != null,
      [e ? "download" : "upload"]: !0
    };
    n(p);
  }, t);
}, Cn = (n, e) => {
  const t = n != null;
  return [(r) => e[0]({
    lengthComputable: t,
    total: n,
    loaded: r
  }), e[1]];
}, Pn = (n) => (...e) => g.asap(() => n(...e)), ho = q.hasStandardBrowserEnv ? (
  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  function() {
    const e = q.navigator && /(msie|trident)/i.test(q.navigator.userAgent), t = document.createElement("a");
    let r;
    function s(i) {
      let o = i;
      return e && (t.setAttribute("href", o), o = t.href), t.setAttribute("href", o), {
        href: t.href,
        protocol: t.protocol ? t.protocol.replace(/:$/, "") : "",
        host: t.host,
        search: t.search ? t.search.replace(/^\?/, "") : "",
        hash: t.hash ? t.hash.replace(/^#/, "") : "",
        hostname: t.hostname,
        port: t.port,
        pathname: t.pathname.charAt(0) === "/" ? t.pathname : "/" + t.pathname
      };
    }
    return r = s(window.location.href), function(o) {
      const u = g.isString(o) ? s(o) : o;
      return u.protocol === r.protocol && u.host === r.host;
    };
  }()
) : (
  // Non standard browser envs (web workers, react-native) lack needed support.
  /* @__PURE__ */ function() {
    return function() {
      return !0;
    };
  }()
), go = q.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(n, e, t, r, s, i) {
      const o = [n + "=" + encodeURIComponent(e)];
      g.isNumber(t) && o.push("expires=" + new Date(t).toGMTString()), g.isString(r) && o.push("path=" + r), g.isString(s) && o.push("domain=" + s), i === !0 && o.push("secure"), document.cookie = o.join("; ");
    },
    read(n) {
      const e = document.cookie.match(new RegExp("(^|;\\s*)(" + n + ")=([^;]*)"));
      return e ? decodeURIComponent(e[3]) : null;
    },
    remove(n) {
      this.write(n, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function mo(n) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(n);
}
function yo(n, e) {
  return e ? n.replace(/\/?\/$/, "") + "/" + e.replace(/^\/+/, "") : n;
}
function ar(n, e) {
  return n && !mo(e) ? yo(n, e) : e;
}
const Ln = (n) => n instanceof z ? { ...n } : n;
function ce(n, e) {
  e = e || {};
  const t = {};
  function r(l, f, p) {
    return g.isPlainObject(l) && g.isPlainObject(f) ? g.merge.call({ caseless: p }, l, f) : g.isPlainObject(f) ? g.merge({}, f) : g.isArray(f) ? f.slice() : f;
  }
  function s(l, f, p) {
    if (g.isUndefined(f)) {
      if (!g.isUndefined(l))
        return r(void 0, l, p);
    } else
      return r(l, f, p);
  }
  function i(l, f) {
    if (!g.isUndefined(f))
      return r(void 0, f);
  }
  function o(l, f) {
    if (g.isUndefined(f)) {
      if (!g.isUndefined(l))
        return r(void 0, l);
    } else
      return r(void 0, f);
  }
  function u(l, f, p) {
    if (p in e)
      return r(l, f);
    if (p in n)
      return r(void 0, l);
  }
  const a = {
    url: i,
    method: i,
    data: i,
    baseURL: o,
    transformRequest: o,
    transformResponse: o,
    paramsSerializer: o,
    timeout: o,
    timeoutMessage: o,
    withCredentials: o,
    withXSRFToken: o,
    adapter: o,
    responseType: o,
    xsrfCookieName: o,
    xsrfHeaderName: o,
    onUploadProgress: o,
    onDownloadProgress: o,
    decompress: o,
    maxContentLength: o,
    maxBodyLength: o,
    beforeRedirect: o,
    transport: o,
    httpAgent: o,
    httpsAgent: o,
    cancelToken: o,
    socketPath: o,
    responseEncoding: o,
    validateStatus: u,
    headers: (l, f) => s(Ln(l), Ln(f), !0)
  };
  return g.forEach(Object.keys(Object.assign({}, n, e)), function(f) {
    const p = a[f] || s, d = p(n[f], e[f], f);
    g.isUndefined(d) && p !== u || (t[f] = d);
  }), t;
}
const ur = (n) => {
  const e = ce({}, n);
  let { data: t, withXSRFToken: r, xsrfHeaderName: s, xsrfCookieName: i, headers: o, auth: u } = e;
  e.headers = o = z.from(o), e.url = nr(ar(e.baseURL, e.url), n.params, n.paramsSerializer), u && o.set(
    "Authorization",
    "Basic " + btoa((u.username || "") + ":" + (u.password ? unescape(encodeURIComponent(u.password)) : ""))
  );
  let a;
  if (g.isFormData(t)) {
    if (q.hasStandardBrowserEnv || q.hasStandardBrowserWebWorkerEnv)
      o.setContentType(void 0);
    else if ((a = o.getContentType()) !== !1) {
      const [l, ...f] = a ? a.split(";").map((p) => p.trim()).filter(Boolean) : [];
      o.setContentType([l || "multipart/form-data", ...f].join("; "));
    }
  }
  if (q.hasStandardBrowserEnv && (r && g.isFunction(r) && (r = r(e)), r || r !== !1 && ho(e.url))) {
    const l = s && i && go.read(i);
    l && o.set(s, l);
  }
  return e;
}, bo = typeof XMLHttpRequest < "u", wo = bo && function(n) {
  return new Promise(function(t, r) {
    const s = ur(n);
    let i = s.data;
    const o = z.from(s.headers).normalize();
    let { responseType: u, onUploadProgress: a, onDownloadProgress: l } = s, f, p, d, m, h;
    function w() {
      m && m(), h && h(), s.cancelToken && s.cancelToken.unsubscribe(f), s.signal && s.signal.removeEventListener("abort", f);
    }
    let y = new XMLHttpRequest();
    y.open(s.method.toUpperCase(), s.url, !0), y.timeout = s.timeout;
    function v() {
      if (!y)
        return;
      const E = z.from(
        "getAllResponseHeaders" in y && y.getAllResponseHeaders()
      ), A = {
        data: !u || u === "text" || u === "json" ? y.responseText : y.response,
        status: y.status,
        statusText: y.statusText,
        headers: E,
        config: n,
        request: y
      };
      or(function(L) {
        t(L), w();
      }, function(L) {
        r(L), w();
      }, A), y = null;
    }
    "onloadend" in y ? y.onloadend = v : y.onreadystatechange = function() {
      !y || y.readyState !== 4 || y.status === 0 && !(y.responseURL && y.responseURL.indexOf("file:") === 0) || setTimeout(v);
    }, y.onabort = function() {
      y && (r(new T("Request aborted", T.ECONNABORTED, n, y)), y = null);
    }, y.onerror = function() {
      r(new T("Network Error", T.ERR_NETWORK, n, y)), y = null;
    }, y.ontimeout = function() {
      let R = s.timeout ? "timeout of " + s.timeout + "ms exceeded" : "timeout exceeded";
      const A = s.transitional || rr;
      s.timeoutErrorMessage && (R = s.timeoutErrorMessage), r(new T(
        R,
        A.clarifyTimeoutError ? T.ETIMEDOUT : T.ECONNABORTED,
        n,
        y
      )), y = null;
    }, i === void 0 && o.setContentType(null), "setRequestHeader" in y && g.forEach(o.toJSON(), function(R, A) {
      y.setRequestHeader(A, R);
    }), g.isUndefined(s.withCredentials) || (y.withCredentials = !!s.withCredentials), u && u !== "json" && (y.responseType = s.responseType), l && ([d, h] = Ge(l, !0), y.addEventListener("progress", d)), a && y.upload && ([p, m] = Ge(a), y.upload.addEventListener("progress", p), y.upload.addEventListener("loadend", m)), (s.cancelToken || s.signal) && (f = (E) => {
      y && (r(!E || E.type ? new ye(null, n, y) : E), y.abort(), y = null);
    }, s.cancelToken && s.cancelToken.subscribe(f), s.signal && (s.signal.aborted ? f() : s.signal.addEventListener("abort", f)));
    const x = co(s.url);
    if (x && q.protocols.indexOf(x) === -1) {
      r(new T("Unsupported protocol " + x + ":", T.ERR_BAD_REQUEST, n));
      return;
    }
    y.send(i || null);
  });
}, vo = (n, e) => {
  const { length: t } = n = n ? n.filter(Boolean) : [];
  if (e || t) {
    let r = new AbortController(), s;
    const i = function(l) {
      if (!s) {
        s = !0, u();
        const f = l instanceof Error ? l : this.reason;
        r.abort(f instanceof T ? f : new ye(f instanceof Error ? f.message : f));
      }
    };
    let o = e && setTimeout(() => {
      o = null, i(new T(`timeout ${e} of ms exceeded`, T.ETIMEDOUT));
    }, e);
    const u = () => {
      n && (o && clearTimeout(o), o = null, n.forEach((l) => {
        l.unsubscribe ? l.unsubscribe(i) : l.removeEventListener("abort", i);
      }), n = null);
    };
    n.forEach((l) => l.addEventListener("abort", i));
    const { signal: a } = r;
    return a.unsubscribe = () => g.asap(u), a;
  }
}, So = function* (n, e) {
  let t = n.byteLength;
  if (!e || t < e) {
    yield n;
    return;
  }
  let r = 0, s;
  for (; r < t; )
    s = r + e, yield n.slice(r, s), r = s;
}, xo = async function* (n, e) {
  for await (const t of Eo(n))
    yield* So(t, e);
}, Eo = async function* (n) {
  if (n[Symbol.asyncIterator]) {
    yield* n;
    return;
  }
  const e = n.getReader();
  try {
    for (; ; ) {
      const { done: t, value: r } = await e.read();
      if (t)
        break;
      yield r;
    }
  } finally {
    await e.cancel();
  }
}, Nn = (n, e, t, r) => {
  const s = xo(n, e);
  let i = 0, o, u = (a) => {
    o || (o = !0, r && r(a));
  };
  return new ReadableStream({
    async pull(a) {
      try {
        const { done: l, value: f } = await s.next();
        if (l) {
          u(), a.close();
          return;
        }
        let p = f.byteLength;
        if (t) {
          let d = i += p;
          t(d);
        }
        a.enqueue(new Uint8Array(f));
      } catch (l) {
        throw u(l), l;
      }
    },
    cancel(a) {
      return u(a), s.return();
    }
  }, {
    highWaterMark: 2
  });
}, nt = typeof fetch == "function" && typeof Request == "function" && typeof Response == "function", lr = nt && typeof ReadableStream == "function", Ro = nt && (typeof TextEncoder == "function" ? /* @__PURE__ */ ((n) => (e) => n.encode(e))(new TextEncoder()) : async (n) => new Uint8Array(await new Response(n).arrayBuffer())), cr = (n, ...e) => {
  try {
    return !!n(...e);
  } catch {
    return !1;
  }
}, Oo = lr && cr(() => {
  let n = !1;
  const e = new Request(q.origin, {
    body: new ReadableStream(),
    method: "POST",
    get duplex() {
      return n = !0, "half";
    }
  }).headers.has("Content-Type");
  return n && !e;
}), kn = 64 * 1024, Ct = lr && cr(() => g.isReadableStream(new Response("").body)), We = {
  stream: Ct && ((n) => n.body)
};
nt && ((n) => {
  ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((e) => {
    !We[e] && (We[e] = g.isFunction(n[e]) ? (t) => t[e]() : (t, r) => {
      throw new T(`Response type '${e}' is not supported`, T.ERR_NOT_SUPPORT, r);
    });
  });
})(new Response());
const Ao = async (n) => {
  if (n == null)
    return 0;
  if (g.isBlob(n))
    return n.size;
  if (g.isSpecCompliantForm(n))
    return (await new Request(q.origin, {
      method: "POST",
      body: n
    }).arrayBuffer()).byteLength;
  if (g.isArrayBufferView(n) || g.isArrayBuffer(n))
    return n.byteLength;
  if (g.isURLSearchParams(n) && (n = n + ""), g.isString(n))
    return (await Ro(n)).byteLength;
}, To = async (n, e) => {
  const t = g.toFiniteNumber(n.getContentLength());
  return t ?? Ao(e);
}, Co = nt && (async (n) => {
  let {
    url: e,
    method: t,
    data: r,
    signal: s,
    cancelToken: i,
    timeout: o,
    onDownloadProgress: u,
    onUploadProgress: a,
    responseType: l,
    headers: f,
    withCredentials: p = "same-origin",
    fetchOptions: d
  } = ur(n);
  l = l ? (l + "").toLowerCase() : "text";
  let m = vo([s, i && i.toAbortSignal()], o), h;
  const w = m && m.unsubscribe && (() => {
    m.unsubscribe();
  });
  let y;
  try {
    if (a && Oo && t !== "get" && t !== "head" && (y = await To(f, r)) !== 0) {
      let A = new Request(e, {
        method: "POST",
        body: r,
        duplex: "half"
      }), C;
      if (g.isFormData(r) && (C = A.headers.get("content-type")) && f.setContentType(C), A.body) {
        const [L, Q] = Cn(
          y,
          Ge(Pn(a))
        );
        r = Nn(A.body, kn, L, Q);
      }
    }
    g.isString(p) || (p = p ? "include" : "omit");
    const v = "credentials" in Request.prototype;
    h = new Request(e, {
      ...d,
      signal: m,
      method: t.toUpperCase(),
      headers: f.normalize().toJSON(),
      body: r,
      duplex: "half",
      credentials: v ? p : void 0
    });
    let x = await fetch(h);
    const E = Ct && (l === "stream" || l === "response");
    if (Ct && (u || E && w)) {
      const A = {};
      ["status", "statusText", "headers"].forEach((se) => {
        A[se] = x[se];
      });
      const C = g.toFiniteNumber(x.headers.get("content-length")), [L, Q] = u && Cn(
        C,
        Ge(Pn(u), !0)
      ) || [];
      x = new Response(
        Nn(x.body, kn, L, () => {
          Q && Q(), w && w();
        }),
        A
      );
    }
    l = l || "text";
    let R = await We[g.findKey(We, l) || "text"](x, n);
    return !E && w && w(), await new Promise((A, C) => {
      or(A, C, {
        data: R,
        headers: z.from(x.headers),
        status: x.status,
        statusText: x.statusText,
        config: n,
        request: h
      });
    });
  } catch (v) {
    throw w && w(), v && v.name === "TypeError" && /fetch/i.test(v.message) ? Object.assign(
      new T("Network Error", T.ERR_NETWORK, n, h),
      {
        cause: v.cause || v
      }
    ) : T.from(v, v && v.code, n, h);
  }
}), Pt = {
  http: Hi,
  xhr: wo,
  fetch: Co
};
g.forEach(Pt, (n, e) => {
  if (n) {
    try {
      Object.defineProperty(n, "name", { value: e });
    } catch {
    }
    Object.defineProperty(n, "adapterName", { value: e });
  }
});
const $n = (n) => `- ${n}`, Po = (n) => g.isFunction(n) || n === null || n === !1, fr = {
  getAdapter: (n) => {
    n = g.isArray(n) ? n : [n];
    const { length: e } = n;
    let t, r;
    const s = {};
    for (let i = 0; i < e; i++) {
      t = n[i];
      let o;
      if (r = t, !Po(t) && (r = Pt[(o = String(t)).toLowerCase()], r === void 0))
        throw new T(`Unknown adapter '${o}'`);
      if (r)
        break;
      s[o || "#" + i] = r;
    }
    if (!r) {
      const i = Object.entries(s).map(
        ([u, a]) => `adapter ${u} ` + (a === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let o = e ? i.length > 1 ? `since :
` + i.map($n).join(`
`) : " " + $n(i[0]) : "as no adapter specified";
      throw new T(
        "There is no suitable adapter to dispatch the request " + o,
        "ERR_NOT_SUPPORT"
      );
    }
    return r;
  },
  adapters: Pt
};
function bt(n) {
  if (n.cancelToken && n.cancelToken.throwIfRequested(), n.signal && n.signal.aborted)
    throw new ye(null, n);
}
function Fn(n) {
  return bt(n), n.headers = z.from(n.headers), n.data = yt.call(
    n,
    n.transformRequest
  ), ["post", "put", "patch"].indexOf(n.method) !== -1 && n.headers.setContentType("application/x-www-form-urlencoded", !1), fr.getAdapter(n.adapter || Ie.adapter)(n).then(function(r) {
    return bt(n), r.data = yt.call(
      n,
      n.transformResponse,
      r
    ), r.headers = z.from(r.headers), r;
  }, function(r) {
    return ir(r) || (bt(n), r && r.response && (r.response.data = yt.call(
      n,
      n.transformResponse,
      r.response
    ), r.response.headers = z.from(r.response.headers))), Promise.reject(r);
  });
}
const dr = "1.7.7", It = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((n, e) => {
  It[n] = function(r) {
    return typeof r === n || "a" + (e < 1 ? "n " : " ") + n;
  };
});
const In = {};
It.transitional = function(e, t, r) {
  function s(i, o) {
    return "[Axios v" + dr + "] Transitional option '" + i + "'" + o + (r ? ". " + r : "");
  }
  return (i, o, u) => {
    if (e === !1)
      throw new T(
        s(o, " has been removed" + (t ? " in " + t : "")),
        T.ERR_DEPRECATED
      );
    return t && !In[o] && (In[o] = !0, console.warn(
      s(
        o,
        " has been deprecated since v" + t + " and will be removed in the near future"
      )
    )), e ? e(i, o, u) : !0;
  };
};
function Lo(n, e, t) {
  if (typeof n != "object")
    throw new T("options must be an object", T.ERR_BAD_OPTION_VALUE);
  const r = Object.keys(n);
  let s = r.length;
  for (; s-- > 0; ) {
    const i = r[s], o = e[i];
    if (o) {
      const u = n[i], a = u === void 0 || o(u, i, n);
      if (a !== !0)
        throw new T("option " + i + " must be " + a, T.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (t !== !0)
      throw new T("Unknown option " + i, T.ERR_BAD_OPTION);
  }
}
const Lt = {
  assertOptions: Lo,
  validators: It
}, re = Lt.validators;
class le {
  constructor(e) {
    this.defaults = e, this.interceptors = {
      request: new An(),
      response: new An()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(e, t) {
    try {
      return await this._request(e, t);
    } catch (r) {
      if (r instanceof Error) {
        let s;
        Error.captureStackTrace ? Error.captureStackTrace(s = {}) : s = new Error();
        const i = s.stack ? s.stack.replace(/^.+\n/, "") : "";
        try {
          r.stack ? i && !String(r.stack).endsWith(i.replace(/^.+\n.+\n/, "")) && (r.stack += `
` + i) : r.stack = i;
        } catch {
        }
      }
      throw r;
    }
  }
  _request(e, t) {
    typeof e == "string" ? (t = t || {}, t.url = e) : t = e || {}, t = ce(this.defaults, t);
    const { transitional: r, paramsSerializer: s, headers: i } = t;
    r !== void 0 && Lt.assertOptions(r, {
      silentJSONParsing: re.transitional(re.boolean),
      forcedJSONParsing: re.transitional(re.boolean),
      clarifyTimeoutError: re.transitional(re.boolean)
    }, !1), s != null && (g.isFunction(s) ? t.paramsSerializer = {
      serialize: s
    } : Lt.assertOptions(s, {
      encode: re.function,
      serialize: re.function
    }, !0)), t.method = (t.method || this.defaults.method || "get").toLowerCase();
    let o = i && g.merge(
      i.common,
      i[t.method]
    );
    i && g.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (h) => {
        delete i[h];
      }
    ), t.headers = z.concat(o, i);
    const u = [];
    let a = !0;
    this.interceptors.request.forEach(function(w) {
      typeof w.runWhen == "function" && w.runWhen(t) === !1 || (a = a && w.synchronous, u.unshift(w.fulfilled, w.rejected));
    });
    const l = [];
    this.interceptors.response.forEach(function(w) {
      l.push(w.fulfilled, w.rejected);
    });
    let f, p = 0, d;
    if (!a) {
      const h = [Fn.bind(this), void 0];
      for (h.unshift.apply(h, u), h.push.apply(h, l), d = h.length, f = Promise.resolve(t); p < d; )
        f = f.then(h[p++], h[p++]);
      return f;
    }
    d = u.length;
    let m = t;
    for (p = 0; p < d; ) {
      const h = u[p++], w = u[p++];
      try {
        m = h(m);
      } catch (y) {
        w.call(this, y);
        break;
      }
    }
    try {
      f = Fn.call(this, m);
    } catch (h) {
      return Promise.reject(h);
    }
    for (p = 0, d = l.length; p < d; )
      f = f.then(l[p++], l[p++]);
    return f;
  }
  getUri(e) {
    e = ce(this.defaults, e);
    const t = ar(e.baseURL, e.url);
    return nr(t, e.params, e.paramsSerializer);
  }
}
g.forEach(["delete", "get", "head", "options"], function(e) {
  le.prototype[e] = function(t, r) {
    return this.request(ce(r || {}, {
      method: e,
      url: t,
      data: (r || {}).data
    }));
  };
});
g.forEach(["post", "put", "patch"], function(e) {
  function t(r) {
    return function(i, o, u) {
      return this.request(ce(u || {}, {
        method: e,
        headers: r ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: i,
        data: o
      }));
    };
  }
  le.prototype[e] = t(), le.prototype[e + "Form"] = t(!0);
});
class Dt {
  constructor(e) {
    if (typeof e != "function")
      throw new TypeError("executor must be a function.");
    let t;
    this.promise = new Promise(function(i) {
      t = i;
    });
    const r = this;
    this.promise.then((s) => {
      if (!r._listeners)
        return;
      let i = r._listeners.length;
      for (; i-- > 0; )
        r._listeners[i](s);
      r._listeners = null;
    }), this.promise.then = (s) => {
      let i;
      const o = new Promise((u) => {
        r.subscribe(u), i = u;
      }).then(s);
      return o.cancel = function() {
        r.unsubscribe(i);
      }, o;
    }, e(function(i, o, u) {
      r.reason || (r.reason = new ye(i, o, u), t(r.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(e) {
    if (this.reason) {
      e(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(e) : this._listeners = [e];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(e) {
    if (!this._listeners)
      return;
    const t = this._listeners.indexOf(e);
    t !== -1 && this._listeners.splice(t, 1);
  }
  toAbortSignal() {
    const e = new AbortController(), t = (r) => {
      e.abort(r);
    };
    return this.subscribe(t), e.signal.unsubscribe = () => this.unsubscribe(t), e.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let e;
    return {
      token: new Dt(function(s) {
        e = s;
      }),
      cancel: e
    };
  }
}
function No(n) {
  return function(t) {
    return n.apply(null, t);
  };
}
function ko(n) {
  return g.isObject(n) && n.isAxiosError === !0;
}
const Nt = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(Nt).forEach(([n, e]) => {
  Nt[e] = n;
});
function pr(n) {
  const e = new le(n), t = qn(le.prototype.request, e);
  return g.extend(t, le.prototype, e, { allOwnKeys: !0 }), g.extend(t, e, null, { allOwnKeys: !0 }), t.create = function(s) {
    return pr(ce(n, s));
  }, t;
}
const _ = pr(Ie);
_.Axios = le;
_.CanceledError = ye;
_.CancelToken = Dt;
_.isCancel = ir;
_.VERSION = dr;
_.toFormData = tt;
_.AxiosError = T;
_.Cancel = _.CanceledError;
_.all = function(e) {
  return Promise.all(e);
};
_.spread = No;
_.isAxiosError = ko;
_.mergeConfig = ce;
_.AxiosHeaders = z;
_.formToJSON = (n) => sr(g.isHTMLForm(n) ? new FormData(n) : n);
_.getAdapter = fr.getAdapter;
_.HttpStatusCode = Nt;
_.default = _;
const $o = 440, Fo = async () => {
  const n = jt();
  try {
    const e = n.getAccountsURL(), t = new Request(`${e}/exit`, {
      method: "GET",
      mode: "no-cors",
      credentials: "include"
    });
    await fetch(t);
  } catch (e) {
    console.log("error", e);
  }
}, Io = () => `${jt().getAccountsURL()}/signin?session_expired=true`, Do = () => localStorage.removeItem("tokens"), hr = (n) => {
  var e;
  if (((e = n == null ? void 0 : n.response) == null ? void 0 : e.status) === $o) {
    Fo(), Do();
    const t = window.location.href;
    setTimeout(
      () => window.location.href = Io() + "?redirect_path=" + t,
      2e3
    );
  }
  throw n;
}, gr = (n) => n, U = _.create();
U.interceptors.response.use(gr, hr);
const $ = class $ {
  static get config() {
    return Uo.getInstance();
  }
};
$.$getPropertiesByOrg = {}, $.getPropertiesByOrg = (e) => ($.$getPropertiesByOrg[e] === void 0 && ($.$getPropertiesByOrg[e] = U.get(`${$.config.getAPIURL()}/v2/orgs/${e}/properties`, {
  headers: $.config.getDefaultHeaders()
})), $.$getPropertiesByOrg[e]), $.getCurrentUser = async () => {
  if ($.$getCurrentUser === void 0) {
    if (!$.config.getToken() || !$.config.getCurrentEnv())
      return null;
    const e = `${$.config.getAPIURL()}/v2/accounts/me`;
    $.$getCurrentUser = U.get(e, {
      headers: {
        ...$.config.getDefaultHeaders()
      },
      params: {
        attributes: "licensing_accounts,is_using_rbac",
        ...$.config.getExcludeAuthorities() && { exclude_attributes: "authorities" }
      }
    }).then((t) => t.data ? ($.config.getUserCallback(t.data), t.data) : ($.$getCurrentUser = void 0, null)).catch(() => ($.$getCurrentUser = void 0, null));
  }
  return $.$getCurrentUser;
}, $.$getAppDetails = {}, $.getAppDetails = async (e) => ($.$getAppDetails[e] === void 0 && ($.$getAppDetails[e] = U.get(`${$.config.getAPIURL()}/v2/apps/${e}/info`, {
  headers: {
    ...$.config.getDefaultHeaders(),
    ...$.config.getLanguageHeaders()
  }
}).then((t) => t.data)), $.$getAppDetails[e]);
let Ye = $;
function jo() {
  let n;
  try {
    n = JSON.parse(localStorage.getItem("tokens") || "{}");
  } catch {
    n = null;
  }
  return n ? n == null ? void 0 : n.access_token : "";
}
var _o = { VITE_MAPBOX_TOKEN: "pk.eyJ1Ijoic3RyaWRlcmVuZ2luZWVyaW5nIiwiYSI6ImNsMWdnM3BrbzBiemQzaHBiaDhja2RleXAifQ.0QfwjSzZeGiEjkkA-0dH6w", VITE_CJS_IGNORE_WARNING: "true", BASE_URL: "/", MODE: "production", DEV: !1, PROD: !0, SSR: !1 };
class Y {
  constructor() {
    this.currentEnv = null, this.accessToken = null, this.hostAppId = null, this.callbacksAfterSetToken = [], this.excludeAuthorities = !1, this.segmentKeyByEnv = {
      qa: "jPsCxtCxCLQ9dtfWIiNF7kyZ23rSrTTk",
      staging: "jH1ssOMCalPvGsSFjt7SmUlPti2AeqJc",
      beta: "jH1ssOMCalPvGsSFjt7SmUlPti2AeqJc",
      prod: "GRbdxrYNDBoFzBtrwKpyFQbTISpDxcyO",
      "internal-docs": "GRbdxrYNDBoFzBtrwKpyFQbTISpDxcyO"
    }, this.amplitudeKeyByEnv = {
      development: "140efae922a09c2e13ffc26a5b671d5f",
      prod: "03e856a0034ec3dca2891a6a527d7aee"
    }, this.getUserCallback = () => null;
  }
  static getInstance() {
    if (typeof window > "u")
      return Y.instance = new Y(), Y.instance;
    const e = window;
    return e.__GLOBAL_CONFIG_INSTANCE__ ? Y.instance = e.__GLOBAL_CONFIG_INSTANCE__ : Y.instance || (Y.instance = new Y(), e.__GLOBAL_CONFIG_INSTANCE__ = Y.instance), Y.instance;
  }
  setToken(e) {
    const t = this.accessToken;
    this.accessToken = e, e && t !== this.accessToken && this.callbacksAfterSetToken.forEach((r) => r());
  }
  getToken() {
    return this.accessToken || "";
  }
  addCallbackAfterSetToken(e) {
    this.getToken() && e(), this.callbacksAfterSetToken.push(e);
  }
  setHostAppId(e) {
    this.hostAppId = e;
  }
  getHostAppId() {
    return this.hostAppId || "";
  }
  setupAxiosInterceptor(e) {
    e.interceptors.response.use(gr, hr);
  }
  setCurrentEnv(e) {
    this.currentEnv = e;
  }
  getCurrentEnv() {
    return this.currentEnv ? this.currentEnv : _o.ENV_NAME;
  }
  getSegmentKey() {
    return this.currentEnv ? this.segmentKeyByEnv[this.currentEnv] : this.segmentKeyByEnv.qa;
  }
  getAnalyticsKey() {
    return this.currentEnv === "prod" ? this.amplitudeKeyByEnv.prod : this.amplitudeKeyByEnv.development;
  }
  getDataBusURL() {
    const e = this.currentEnv === "internal-docs" ? "qa" : this.currentEnv;
    return e === "prod" ? "https://databus.cropwise.com/integrations" : `https://${e}.databus.cropwise.com/integrations`;
  }
  getConnectURL() {
    return (this.currentEnv === "internal-docs" ? "qa" : this.currentEnv) === "prod" ? "https://connect.cropwise.com/" : "https://dev.connect.cropwise.com/";
  }
  getAccountsURL() {
    const e = this.currentEnv === "internal-docs" ? "qa" : this.currentEnv;
    return e === "prod" ? `https://accounts${this.getCurrentHost()}` : `https://${e}.accounts${this.getCurrentHost()}`;
  }
  getFarmSettingsURL() {
    const e = this.currentEnv === "internal-docs" ? "qa" : this.currentEnv;
    return `https://${e === "prod" ? "" : e === "beta" ? "staging." : `${e}.`}app.cropwise.com`;
  }
  getAPIWSURL() {
    return `${this.getAPIURL().replace("http", "ws")}/v2/notifications/connect`;
  }
  getAPIURL() {
    switch (this.currentEnv) {
      case "internal-docs":
        return "/api";
      case "prod":
        return "https://api.base.cropwise.com";
      case "beta":
        return "https://api.staging.beta.base.strider.ag";
      case void 0:
      case null:
      case "qa":
        return "https://api.qa.base.cropwise.com";
      case "staging":
        return "https://api.staging.base.cropwise.com";
      default:
        return `https://api.${this.currentEnv}.base.cropwise.com`;
    }
  }
  getConnectAPIURL() {
    switch (this.currentEnv) {
      case "internal-docs":
        return "/api";
      case "prod":
        return "https://prod-api.databus.cropwise.com";
      case void 0:
      case null:
      case "qa":
      case "staging":
      case "beta":
        return "https://qa-api.databus.cropwise.com";
      default:
        return `https://${this.currentEnv}-api.databus.cropwise.com`;
    }
  }
  getRolloutKey() {
    switch (this.currentEnv) {
      case "internal-docs":
      case "prod":
        return "5fc6828040159f74cfc07a1d";
      case "qa":
        return "613083f3e32f137d9dd2cc18";
      case "staging":
      case "beta":
        return "613083bbfd8c0053b608ad75";
      default:
        return "613083f3e32f137d9dd2cc18";
    }
  }
  getLaunchDarklyClientID() {
    switch (this.currentEnv) {
      case "internal-docs":
      case "prod":
        return "65c62b9c3a108e106cee1347";
      case "qa":
        return "65fde073f36a690f25593637";
      case "staging":
      case "beta":
        return "65c62bc31517a50f2d9df985";
      default:
        return "65fde073f36a690f25593637";
    }
  }
  getCurrentHost() {
    return ".cropwise.com";
  }
  getDefaultHeaders() {
    return {
      Authorization: `Bearer ${this.accessToken || jo()}`
    };
  }
  getLanguageHeaders() {
    return {
      "Accept-Language": ge.language
    };
  }
  getI18NInstance() {
    return { useTranslation: ni, CWElementsI18NProvider: ti };
  }
  setExcludeAuthorities(e) {
    this.excludeAuthorities = e;
  }
  getExcludeAuthorities() {
    return this.excludeAuthorities;
  }
  /**
   * @deprecated This method is deprecated. Please use the getCurrentUser method instead.
   */
  setUserCallback(e) {
    this.getUserCallback = e;
  }
  getCurrentUser() {
    return Ye.getCurrentUser();
  }
  getAppDetails() {
    return this.hostAppId ? en[this.hostAppId] ? Promise.resolve(en[this.hostAppId]) : Ye.getAppDetails(this.hostAppId) : null;
  }
}
const Uo = Y;
function jt() {
  return Y.getInstance();
}
var Bo = /* @__PURE__ */ ((n) => (n.HECTARE = "HECTARE", n.ACRE = "ACRE", n))(Bo || {}), Pe = /* @__PURE__ */ ((n) => (n.FIELD = "FIELD", n.ORGANIZATION = "ORGANIZATION", n))(Pe || {});
const D = /* @__PURE__ */ new Map();
function Wo(n, e) {
  const t = async (a) => {
    if (!D.has(`getQuotaInfo-${a}`)) {
      const l = U.get(`${n}/v2/quotas/${a}`, e).then((f) => f.data);
      D.set(`getQuotaInfo-${a}`, l);
    }
    return D.get(`getQuotaInfo-${a}`);
  }, r = async (a) => {
    if (!D.has(`getApps-${a}`)) {
      const l = U.get(`${n}/v2/store/apps?workspace_id=${a}`, e).then((f) => f.data.content);
      D.set(`getApps-${a}`, l);
    }
    return D.get(`getApps-${a}`);
  }, s = async (a) => {
    if (!D.has(`getContracts-${a}`)) {
      const l = U.get(`${n}/v2/workspaces/${a}/contracts?size=${Number.MAX_SAFE_INTEGER}`, e).then((f) => f.data.content);
      D.set(`getContracts-${a}`, l);
    }
    return D.get(`getContracts-${a}`);
  }, i = async (a) => U.get(`${n}/v2/contracts/${a}/entities?size=${Number.MAX_SAFE_INTEGER}`, e).then((l) => l.data.content), o = async (a) => (await U.post(
    `${n}/v2/auth/verify`,
    { operations: a },
    e
  )).data, u = async (a, l = 0, f = !1) => U.get(
    `${n}/v2/orgs?attributes=workspaces,total_area&workspaces=${a}` + (f ? `&force_list_unexplicit_orgs=true&size=20&page=${l}` : ""),
    e
  );
  return {
    verifyPermissions: o,
    loadAppsAndContracts: async (a) => {
      const l = (m) => {
        const h = /* @__PURE__ */ new Date(), w = new Date(m.start), y = new Date(m.end);
        return h >= w && h <= y;
      }, f = async (m, h, w, y) => {
        const v = await t(m.id);
        return {
          id: h.app_id,
          name: y.name,
          icon: y.icon_uri,
          contractId: h.id,
          areaUnit: h.quota_unit,
          quotaId: m.id,
          total: m.limit,
          assigned: m.usage,
          refundable: v.refundable,
          ...w.reduce(
            (x, E) => (x.usageByEntity[E.entity_id] = E.value, x.allocationByEntity[E.entity_id] = E.allocation_date, x),
            {
              usageByEntity: {},
              allocationByEntity: {}
            }
          )
        };
      }, p = (m) => Object.keys(m).sort((h, w) => m[h].name.localeCompare(m[w].name)).reduce((h, w) => (h[w] = m[w], h), {});
      return (async () => {
        const [m, h] = await Promise.all([
          r(a),
          s(a)
        ]), w = {}, y = {};
        return await Promise.all(
          h.map(async (v) => {
            var x;
            if (l(v) && ((x = v.quotas) != null && x.length)) {
              const E = v.quotas.find((L) => L.entity_type === Pe.FIELD), R = v.quotas.find(
                (L) => L.entity_type === Pe.ORGANIZATION
              ), A = m.find((L) => L.id === v.app_id), C = await i(v.id);
              A && E && (w[v.app_id] = await f(
                E,
                v,
                C.filter((L) => L.entity_type === Pe.FIELD),
                A
              )), A && R && (y[v.app_id] = await f(
                R,
                v,
                C.filter((L) => L.entity_type === Pe.ORGANIZATION),
                A
              ));
            }
          })
        ), {
          fieldQuotaByApp: p(w),
          organizationQuotaByApp: p(y)
        };
      })();
    },
    loadActiveSeasonFields: async (a) => {
      if (!D.has(`loadActiveSeasonFields-${a}`)) {
        const l = U.get(`${n}/v2/properties/${a}/season-fields`, e).then(
          (f) => f.data.content.filter((p) => new Date(p.end_date) > /* @__PURE__ */ new Date())
        );
        D.set(`loadActiveSeasonFields-${a}`, l);
      }
      return D.get(`loadActiveSeasonFields-${a}`);
    },
    loadOrganizations: async (a) => {
      const { allowed_operations: l } = await o([
        { resource: "crn:system", action: "members:write" }
      ]), f = l.length === 1, p = await u(a, 0, f);
      if (p.data.total_pages > 1) {
        const d = [];
        for (let h = 1; h < p.data.total_pages; h++)
          d.push(u(a, h, f));
        const m = await Promise.all(d);
        return [
          ...p.data.content,
          ...m.reduce((h, w) => [...h, ...w.data.content], [])
        ];
      }
      return p.data.content;
    },
    loadProperties: async (a) => {
      if (!D.has(`loadProperties-${a}`)) {
        const l = U.get(`${n}/v2/orgs/${a}/properties`, e).then((f) => f.data.content);
        D.set(`loadProperties-${a}`, l);
      }
      return D.get(`loadProperties-${a}`);
    },
    loadFields: async (a) => {
      if (!D.has(`loadFields-${a}`)) {
        const l = U.get(
          `${n}/v2/properties/${a}/fields?attributes=geometry`,
          e
        ).then((f) => f.data.content).then((f) => f.reduce((d, m) => {
          const h = m.calculated_area ?? m.declared_area;
          return h && m.geometry && d.push({
            ...m,
            area: h
          }), d;
        }, []));
        D.set(`loadFields-${a}`, l);
      }
      return D.get(`loadFields-${a}`);
    },
    saveContractEntities: async ({
      currentFieldQuota: a,
      selectedFields: l,
      selectedUpdatedFields: f,
      fields: p
    }) => {
      const d = [];
      if (a) {
        const m = Object.keys(a.usageByEntity), h = m.filter(
          (v) => !l.includes(v)
        ), w = l.filter((v) => !m.includes(v)), y = Object.entries(f).filter(([, v]) => v).map(([v]) => v);
        h.length > 0 && d.push(
          U.delete(`${n}/v2/contracts/${a.contractId}/entities`, {
            ...e,
            data: h
          })
        ), (w.length > 0 || y.length > 0) && d.push(
          U.post(
            `${n}/v2/contracts/${a.contractId}/entities`,
            {
              quota: a.quotaId,
              entities: [...w, ...y].map((v) => {
                var x, E;
                return {
                  key: v,
                  value: (x = p.get(v)) == null ? void 0 : x.area,
                  entity_crn: (E = p.get(v)) == null ? void 0 : E.crn
                };
              })
            },
            e
          )
        );
      }
      return Promise.all(d);
    },
    saveOrganizationQuota: async ({
      currentOrgQuota: a,
      orgQuotasCurrentValue: l
    }) => {
      const f = [];
      if (a) {
        const p = a.usageByEntity, d = [], m = [];
        Object.entries(l).forEach(([h, w]) => {
          p[h] && p[h] !== w && d.push(h), (!p[h] || p[h] !== w) && m.push({
            orgId: h,
            value: w
          });
        }), Object.keys(p).forEach((h) => {
          l[h] || d.push(h);
        }), d.length > 0 && f.push(
          U.delete(
            `${n}/v2/contracts/${a.contractId}/entities?entity_type=ORGANIZATION`,
            {
              ...e,
              data: d
            }
          )
        ), m.length > 0 && f.push(
          U.post(
            `${n}/v2/contracts/${a.contractId}/entities`,
            {
              quota: a.quotaId,
              entities: m.map((h) => ({
                key: h.orgId,
                value: h.value
              }))
            },
            e
          )
        );
      }
      return Promise.all(f);
    },
    loadEntities: (a, l) => {
      const f = `loadEntities-${a}-${(l == null ? void 0 : l.last_key) ?? "first"}`;
      if (!D.has(f)) {
        const p = U.get(
          `${n}/v2/workspaces/${a}/organizations-with-properties-and-fields?size=1000`,
          {
            ...e,
            params: l
          }
        );
        D.set(f, p);
      }
      return D.get(f);
    }
  };
}
const be = jt();
function Mo(n) {
  be.setToken(n);
}
function Ho(n) {
  be.setupAxiosInterceptor(n);
}
function Vo(n) {
  be.setHostAppId(n);
}
function qo(n) {
  return be.setUserCallback(n);
}
function zo(n) {
  be.setExcludeAuthorities(n);
}
function Yo({
  environment: n,
  token: e,
  hostAppId: t,
  axiosInstance: r,
  getCurrentUserCallback: s,
  excludeAuthorities: i = !0
}) {
  be.setCurrentEnv(n), e && Mo(e), r && Ho(r), t && Vo(t), s && qo(s), i && zo(i);
}
export {
  Bo as AreaUnit,
  Y as CWElementsConfig,
  ti as CWElementsI18NProvider,
  Ye as CWElementsSharedService,
  Pe as EntityType,
  Wo as QuotaMgtService,
  Go as i18nInstance,
  Yo as initCWElements,
  Jo as loadPackageTranslations,
  gr as passThroughResponseInterceptor,
  U as request,
  hr as sessionExpiredInterceptor,
  zo as setExcludeAuthorities,
  Vo as setHostAppId,
  Mo as setToken,
  qo as setUserCallback,
  Ho as setupAxiosInterceptor,
  jt as useConfig,
  ni as useTranslation
};
